[
    {
        "id": 83,
        "family_name": "Abel",
        "google_family_name": "Abel",
        "websafe_name": "Abel",
        "provider": "google",
        "foundry": "IBM",
        "serif": "sans-serif",
        "axes": null,
        "sort": 0,
        "is_active": false,
        "variable": false,
        "open_source": true,
        "license": null,
        "variants": [
            {
                "vid": 289,
                "family_id": 83,
                "sort": 0,
                "file_name": null,
                "name": "Regular",
                "google_variant_name": "400",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 1,
        "family_name": "Aften Screen",
        "google_family_name": null,
        "websafe_name": "AftenScreen",
        "provider": "cargo",
        "foundry": "Monokrom",
        "serif": "sans-serif",
        "axes": null,
        "sort": 2,
        "is_active": false,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 1,
                "family_id": 1,
                "sort": 0,
                "file_name": "AftenScreen-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 2,
                "family_id": 1,
                "sort": 1,
                "file_name": "AftenScreen-Italic",
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 3,
                "family_id": 1,
                "sort": 2,
                "file_name": "AftenScreen-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 157,
        "family_name": "Arial Black",
        "google_family_name": null,
        "websafe_name": "ArialBlack",
        "provider": "system",
        "foundry": "Robin Nicholas, Patricia Saunders",
        "serif": "sans-serif",
        "axes": null,
        "sort": 7,
        "is_active": true,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 439,
                "family_id": 157,
                "sort": 0,
                "file_name": null,
                "name": "",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "900",
                "css_font_fvd": "n4",
                "css_font_family": "'Arial Black', Arial, sans-serif, Arial Black;",
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 250,
        "family_name": "Arizona Sans Variable",
        "google_family_name": null,
        "websafe_name": "ArizonaSansVariable",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "sans-serif",
        "axes": [
            {
                "id": 2,
                "title": "Serif",
                "min": 0,
                "max": 1,
                "step": 0.01,
                "css_fvs": "SRFF"
            },
            {
                "id": 0,
                "title": "Weight",
                "min": 200,
                "max": 700,
                "step": 1,
                "css_fvs": "wght"
            },
            {
                "id": 1,
                "title": "Slant",
                "min": -14,
                "max": 0,
                "step": 0.1,
                "css_fvs": "slnt"
            }
        ],
        "sort": 8,
        "is_active": true,
        "variable": true,
        "open_source": false,
        "license": "/*\n * This CSS file has been generated and is served by Cargo Collective Inc\n * and is authorized to be used on Cargo Collective Inc only.\n *\n * This CSS resource incorporates links to font software which is\n * the valuable copyrighted property of Dinamo Typefaces. You may not\n * attempt to copy, install, redistribute, convert, modify or reverse\n * engineer this font software. Please contact Dinamo with any\n * questions: https://abcdinamo.com/\n */",
        "variants": [
            {
                "vid": 923,
                "family_id": 250,
                "sort": 0,
                "file_name": "CargoArizonaPlusVariable",
                "name": "Thin",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n2",
                "css_font_family": null,
                "css_font_fvs": "'wght' 200, 'slnt' 0, 'SRFF' 0",
                "staff_pick": false
            },
            {
                "vid": 924,
                "family_id": 250,
                "sort": 1,
                "file_name": "CargoArizonaPlusVariable",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": "'wght' 300, 'slnt' 0, 'SRFF' 0",
                "staff_pick": false
            },
            {
                "vid": 925,
                "family_id": 250,
                "sort": 2,
                "file_name": "CargoArizonaPlusVariable",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' 0, 'SRFF' 0",
                "staff_pick": false
            },
            {
                "vid": 926,
                "family_id": 250,
                "sort": 3,
                "file_name": "CargoArizonaPlusVariable",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": "'wght' 500, 'slnt' 0, 'SRFF' 0",
                "staff_pick": false
            },
            {
                "vid": 927,
                "family_id": 250,
                "sort": 4,
                "file_name": "CargoArizonaPlusVariable",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": "'wght' 700, 'slnt' 0, 'SRFF' 0",
                "staff_pick": false
            },
            {
                "vid": 944,
                "family_id": 250,
                "sort": 5,
                "file_name": "CargoArizonaPlusItalicVariable",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "200 700",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' -14, 'SRFF' 0",
                "staff_pick": false
            }
        ]
    },
    {
        "id": 251,
        "family_name": "Arizona Flare Variable",
        "google_family_name": null,
        "websafe_name": "ArizonaFlareVariable",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "serif",
        "axes": [
            {
                "id": 2,
                "title": "Serif",
                "min": 0,
                "max": 1,
                "step": 0.01,
                "css_fvs": "SRFF"
            },
            {
                "id": 0,
                "title": "Weight",
                "min": 200,
                "max": 700,
                "step": 1,
                "css_fvs": "wght"
            },
            {
                "id": 1,
                "title": "Slant",
                "min": -14,
                "max": 0,
                "step": 0.1,
                "css_fvs": "slnt"
            }
        ],
        "sort": 9,
        "is_active": true,
        "variable": true,
        "open_source": false,
        "license": "/*\n * This CSS file has been generated and is served by Cargo Collective Inc\n * and is authorized to be used on Cargo Collective Inc only.\n *\n * This CSS resource incorporates links to font software which is\n * the valuable copyrighted property of Dinamo Typefaces. You may not\n * attempt to copy, install, redistribute, convert, modify or reverse\n * engineer this font software. Please contact Dinamo with any\n * questions: https://abcdinamo.com/\n */",
        "variants": [
            {
                "vid": 922,
                "family_id": 251,
                "sort": 0,
                "file_name": "CargoArizonaPlusVariable",
                "name": "Thin",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n2",
                "css_font_family": null,
                "css_font_fvs": "'wght' 200, 'slnt' 0, 'SRFF' 0.25",
                "staff_pick": false
            },
            {
                "vid": 928,
                "family_id": 251,
                "sort": 1,
                "file_name": "CargoArizonaPlusVariable",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": "'wght' 300, 'slnt' 0, 'SRFF' 0.25",
                "staff_pick": false
            },
            {
                "vid": 929,
                "family_id": 251,
                "sort": 2,
                "file_name": "CargoArizonaPlusVariable",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' 0, 'SRFF' 0.25",
                "staff_pick": false
            },
            {
                "vid": 930,
                "family_id": 251,
                "sort": 3,
                "file_name": "CargoArizonaPlusVariable",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": "'wght' 500, 'slnt' 0, 'SRFF' 0.25",
                "staff_pick": false
            },
            {
                "vid": 931,
                "family_id": 251,
                "sort": 4,
                "file_name": "CargoArizonaPlusVariable",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": "'wght' 700, 'slnt' 0, 'SRFF' 0.25",
                "staff_pick": false
            },
            {
                "vid": 945,
                "family_id": 251,
                "sort": 5,
                "file_name": "CargoArizonaPlusItalicVariable",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "200 700",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' -14, 'SRFF' 0.25",
                "staff_pick": false
            }
        ]
    },
    {
        "id": 252,
        "family_name": "Arizona Mix Variable",
        "google_family_name": null,
        "websafe_name": "ArizonaMixVariable",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "serif",
        "axes": [
            {
                "id": 2,
                "title": "Serif",
                "min": 0,
                "max": 1,
                "step": 0.01,
                "css_fvs": "SRFF"
            },
            {
                "id": 0,
                "title": "Weight",
                "min": 200,
                "max": 700,
                "step": 1,
                "css_fvs": "wght"
            },
            {
                "id": 1,
                "title": "Slant",
                "min": -14,
                "max": 0,
                "step": 0.1,
                "css_fvs": "slnt"
            }
        ],
        "sort": 10,
        "is_active": true,
        "variable": true,
        "open_source": false,
        "license": "/*\n * This CSS file has been generated and is served by Cargo Collective Inc\n * and is authorized to be used on Cargo Collective Inc only.\n *\n * This CSS resource incorporates links to font software which is\n * the valuable copyrighted property of Dinamo Typefaces. You may not\n * attempt to copy, install, redistribute, convert, modify or reverse\n * engineer this font software. Please contact Dinamo with any\n * questions: https://abcdinamo.com/\n */",
        "variants": [
            {
                "vid": 921,
                "family_id": 252,
                "sort": 0,
                "file_name": "CargoArizonaPlusVariable",
                "name": "Thin",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n2",
                "css_font_family": null,
                "css_font_fvs": "'wght' 200, 'slnt' 0, 'SRFF' 0.5",
                "staff_pick": false
            },
            {
                "vid": 932,
                "family_id": 252,
                "sort": 1,
                "file_name": "CargoArizonaPlusVariable",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": "'wght' 300, 'slnt' 0, 'SRFF' 0.5",
                "staff_pick": false
            },
            {
                "vid": 933,
                "family_id": 252,
                "sort": 2,
                "file_name": "CargoArizonaPlusVariable",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' 0, 'SRFF' 0.5",
                "staff_pick": false
            },
            {
                "vid": 935,
                "family_id": 252,
                "sort": 3,
                "file_name": "CargoArizonaPlusVariable",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": "'wght' 500, 'slnt' 0, 'SRFF' 0.5",
                "staff_pick": false
            },
            {
                "vid": 937,
                "family_id": 252,
                "sort": 4,
                "file_name": "CargoArizonaPlusVariable",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": "'wght' 700, 'slnt' 0, 'SRFF' 0.5",
                "staff_pick": false
            },
            {
                "vid": 946,
                "family_id": 252,
                "sort": 5,
                "file_name": "CargoArizonaPlusItalicVariable",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "200 700",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' -14, 'SRFF' 0.5",
                "staff_pick": false
            }
        ]
    },
    {
        "id": 253,
        "family_name": "Arizona Text Variable",
        "google_family_name": null,
        "websafe_name": "ArizonaTextVariable",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "serif",
        "axes": [
            {
                "id": 2,
                "title": "Serif",
                "min": 0,
                "max": 1,
                "step": 0.01,
                "css_fvs": "SRFF"
            },
            {
                "id": 0,
                "title": "Weight",
                "min": 200,
                "max": 700,
                "step": 1,
                "css_fvs": "wght"
            },
            {
                "id": 1,
                "title": "Slant",
                "min": -14,
                "max": 0,
                "step": 0.1,
                "css_fvs": "slnt"
            }
        ],
        "sort": 11,
        "is_active": true,
        "variable": true,
        "open_source": false,
        "license": "/*\n * This CSS file has been generated and is served by Cargo Collective Inc\n * and is authorized to be used on Cargo Collective Inc only.\n *\n * This CSS resource incorporates links to font software which is\n * the valuable copyrighted property of Dinamo Typefaces. You may not\n * attempt to copy, install, redistribute, convert, modify or reverse\n * engineer this font software. Please contact Dinamo with any\n * questions: https://abcdinamo.com/\n */",
        "variants": [
            {
                "vid": 920,
                "family_id": 253,
                "sort": 0,
                "file_name": "CargoArizonaPlusVariable",
                "name": "Thin",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n2",
                "css_font_family": null,
                "css_font_fvs": "'wght' 200, 'slnt' 0, 'SRFF' 0.75",
                "staff_pick": false
            },
            {
                "vid": 934,
                "family_id": 253,
                "sort": 1,
                "file_name": "CargoArizonaPlusVariable",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": "'wght' 300, 'slnt' 0, 'SRFF' 0.75",
                "staff_pick": false
            },
            {
                "vid": 936,
                "family_id": 253,
                "sort": 2,
                "file_name": "CargoArizonaPlusVariable",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' 0, 'SRFF' 0.75",
                "staff_pick": false
            },
            {
                "vid": 938,
                "family_id": 253,
                "sort": 3,
                "file_name": "CargoArizonaPlusVariable",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": "'wght' 500, 'slnt' 0, 'SRFF' 0.75",
                "staff_pick": false
            },
            {
                "vid": 939,
                "family_id": 253,
                "sort": 4,
                "file_name": "CargoArizonaPlusVariable",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": "'wght' 700, 'slnt' 0, 'SRFF' 0.75",
                "staff_pick": false
            },
            {
                "vid": 947,
                "family_id": 253,
                "sort": 5,
                "file_name": "CargoArizonaPlusItalicVariable",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "200 700",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' -14, 'SRFF' 0.75",
                "staff_pick": false
            }
        ]
    },
    {
        "id": 254,
        "family_name": "Arizona Serif Variable",
        "google_family_name": null,
        "websafe_name": "ArizonaSerifVariable",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "serif",
        "axes": [
            {
                "id": 2,
                "title": "Serif",
                "min": 0,
                "max": 1,
                "step": 0.01,
                "css_fvs": "SRFF"
            },
            {
                "id": 0,
                "title": "Weight",
                "min": 200,
                "max": 700,
                "step": 1,
                "css_fvs": "wght"
            },
            {
                "id": 1,
                "title": "Slant",
                "min": -14,
                "max": 0,
                "step": 0.1,
                "css_fvs": "slnt"
            }
        ],
        "sort": 12,
        "is_active": true,
        "variable": true,
        "open_source": false,
        "license": "/*\n * This CSS file has been generated and is served by Cargo Collective Inc\n * and is authorized to be used on Cargo Collective Inc only.\n *\n * This CSS resource incorporates links to font software which is\n * the valuable copyrighted property of Dinamo Typefaces. You may not\n * attempt to copy, install, redistribute, convert, modify or reverse\n * engineer this font software. Please contact Dinamo with any\n * questions: https://abcdinamo.com/\n */",
        "variants": [
            {
                "vid": 919,
                "family_id": 254,
                "sort": 0,
                "file_name": "CargoArizonaPlusVariable",
                "name": "Thin",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n2",
                "css_font_family": null,
                "css_font_fvs": "'wght' 200, 'slnt' 0, 'SRFF' 1",
                "staff_pick": true
            },
            {
                "vid": 940,
                "family_id": 254,
                "sort": 1,
                "file_name": "CargoArizonaPlusVariable",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": "'wght' 300, 'slnt' 0, 'SRFF' 1",
                "staff_pick": true
            },
            {
                "vid": 941,
                "family_id": 254,
                "sort": 2,
                "file_name": "CargoArizonaPlusVariable",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' 0, 'SRFF' 1",
                "staff_pick": true
            },
            {
                "vid": 942,
                "family_id": 254,
                "sort": 3,
                "file_name": "CargoArizonaPlusVariable",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": "'wght' 500, 'slnt' 0, 'SRFF' 1",
                "staff_pick": true
            },
            {
                "vid": 943,
                "family_id": 254,
                "sort": 4,
                "file_name": "CargoArizonaPlusVariable",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": "'wght' 700, 'slnt' 0, 'SRFF' 1",
                "staff_pick": true
            },
            {
                "vid": 948,
                "family_id": 254,
                "sort": 5,
                "file_name": "CargoArizonaPlusItalicVariable",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "200 700",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' -14, 'SRFF' 1",
                "staff_pick": true
            }
        ]
    },
    {
        "id": 261,
        "family_name": "Adobe Arno Pro",
        "google_family_name": null,
        "websafe_name": "AdobeArnoPro",
        "provider": "cargo",
        "foundry": null,
        "serif": "serif",
        "axes": null,
        "sort": 13,
        "is_active": true,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 973,
                "family_id": 261,
                "sort": 0,
                "file_name": "ArnoPro-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 974,
                "family_id": 261,
                "sort": 1,
                "file_name": "ArnoPro-Italic",
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 975,
                "family_id": 261,
                "sort": 2,
                "file_name": "ArnoPro-SemiBold",
                "name": "Semi Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "600",
                "css_font_fvd": "n6",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 976,
                "family_id": 261,
                "sort": 3,
                "file_name": "ArnoPro-SemiBoldItalic",
                "name": "Semi Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "600",
                "css_font_fvd": "i6",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 977,
                "family_id": 261,
                "sort": 4,
                "file_name": "ArnoPro-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 978,
                "family_id": 261,
                "sort": 5,
                "file_name": "ArnoPro-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 4,
        "family_name": "Authentic Sans",
        "google_family_name": null,
        "websafe_name": "AuthenticSans",
        "provider": "cargo",
        "foundry": "Authentic",
        "serif": "sans-serif",
        "axes": null,
        "sort": 14,
        "is_active": true,
        "variable": false,
        "open_source": true,
        "license": "/*\n * https://authentic.website/\n */",
        "variants": [
            {
                "vid": 10,
                "family_id": 4,
                "sort": 0,
                "file_name": "AuthenticSans-60",
                "name": "60",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 11,
                "family_id": 4,
                "sort": 1,
                "file_name": "AuthenticSans-90",
                "name": "90",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 12,
                "family_id": 4,
                "sort": 2,
                "file_name": "AuthenticSans-130",
                "name": "130",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "500",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 13,
                "family_id": 4,
                "sort": 3,
                "file_name": "AuthenticSans-150",
                "name": "150",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 5,
        "family_name": "Authentic Sans Condensed",
        "google_family_name": null,
        "websafe_name": "AuthenticSansCondensed",
        "provider": "cargo",
        "foundry": "Authentic",
        "serif": "sans-serif",
        "axes": null,
        "sort": 15,
        "is_active": true,
        "variable": false,
        "open_source": true,
        "license": "/*\n * https://authentic.website/\n */",
        "variants": [
            {
                "vid": 14,
                "family_id": 5,
                "sort": 0,
                "file_name": "AuthenticSansCondensed-60",
                "name": "60",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 15,
                "family_id": 5,
                "sort": 1,
                "file_name": "AuthenticSansCondensed-90",
                "name": "90",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 16,
                "family_id": 5,
                "sort": 2,
                "file_name": "AuthenticSansCondensed-130",
                "name": "130",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "500",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 17,
                "family_id": 5,
                "sort": 3,
                "file_name": "AuthenticSansCondensed-150",
                "name": "150",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 8,
        "family_name": "Benton Sans",
        "google_family_name": null,
        "websafe_name": "BentonSans",
        "provider": "cargo",
        "foundry": "Font Bureau",
        "serif": "sans-serif",
        "axes": null,
        "sort": 20,
        "is_active": false,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 26,
                "family_id": 8,
                "sort": 0,
                "file_name": "BentonSans-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 27,
                "family_id": 8,
                "sort": 1,
                "file_name": "BentonSans-RegularItalic",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 24,
                "family_id": 8,
                "sort": 2,
                "file_name": "BentonSans-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 25,
                "family_id": 8,
                "sort": 3,
                "file_name": "BentonSans-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 22,
                "family_id": 8,
                "sort": 4,
                "file_name": "BentonSans-Black",
                "name": "Black",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "900",
                "css_font_fvd": "n9",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 23,
                "family_id": 8,
                "sort": 5,
                "file_name": "BentonSans-BlackItalic",
                "name": "Black Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "900",
                "css_font_fvd": "i9",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 9,
        "family_name": "Benton Sans Condensed",
        "google_family_name": null,
        "websafe_name": "BentonSansCondensed",
        "provider": "cargo",
        "foundry": "Font Bureau",
        "serif": "sans-serif",
        "axes": null,
        "sort": 21,
        "is_active": false,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 31,
                "family_id": 9,
                "sort": 0,
                "file_name": "BentonSansCondensed-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 30,
                "family_id": 9,
                "sort": 1,
                "file_name": "BentonSansCondensed-RegularItalic",
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 28,
                "family_id": 9,
                "sort": 2,
                "file_name": "BentonSansCondensed-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 29,
                "family_id": 9,
                "sort": 3,
                "file_name": "BentonSansCondensed-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 235,
        "family_name": "Benton Sans Extra Compressed",
        "google_family_name": null,
        "websafe_name": "BentonSansExtraCompressed",
        "provider": "cargo",
        "foundry": "Font Bureau",
        "serif": "sans-serif",
        "axes": null,
        "sort": 22,
        "is_active": false,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 763,
                "family_id": 235,
                "sort": 0,
                "file_name": "BentonSansExtraCompressed-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 764,
                "family_id": 235,
                "sort": 1,
                "file_name": "BentonSansExtraCompressed-Italic",
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 765,
                "family_id": 235,
                "sort": 2,
                "file_name": "BentonSansExtraCompressed-Medium",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "500",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 766,
                "family_id": 235,
                "sort": 3,
                "file_name": "BentonSansExtraCompressed-MediumItalic",
                "name": "Medium Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "500",
                "css_font_fvd": "i5",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 767,
                "family_id": 235,
                "sort": 4,
                "file_name": "BentonSansExtraCompressed-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 768,
                "family_id": 235,
                "sort": 5,
                "file_name": "BentonSansExtraCompressed-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 769,
                "family_id": 235,
                "sort": 6,
                "file_name": "BentonSansExtraCompressed-Black",
                "name": "Black",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "900",
                "css_font_fvd": "n9",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 770,
                "family_id": 235,
                "sort": 7,
                "file_name": "BentonSansExtraCompressed-BlackItalic",
                "name": "Black Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "900",
                "css_font_fvd": "i9",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 10,
        "family_name": "Big Caslon FB",
        "google_family_name": null,
        "websafe_name": "BigCaslonFB",
        "provider": "cargo",
        "foundry": "Matthew Carter",
        "serif": "serif",
        "axes": null,
        "sort": 23,
        "is_active": true,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 35,
                "family_id": 10,
                "sort": 0,
                "file_name": "BigCaslonFB-Roman",
                "name": "Roman",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 34,
                "family_id": 10,
                "sort": 1,
                "file_name": "BigCaslonFB-Italic",
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 32,
                "family_id": 10,
                "sort": 2,
                "file_name": "BigCaslonFB-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 33,
                "family_id": 10,
                "sort": 3,
                "file_name": "BigCaslonFB-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 11,
        "family_name": "Bureau Grot",
        "google_family_name": null,
        "websafe_name": "BureauGrot",
        "provider": "cargo",
        "foundry": "Font Bureau",
        "serif": "sans-serif",
        "axes": null,
        "sort": 24,
        "is_active": false,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 37,
                "family_id": 11,
                "sort": 0,
                "file_name": "BureauGrot-Book",
                "name": "Book",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 36,
                "family_id": 11,
                "sort": 1,
                "file_name": "BureauGrot-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1185,
                "family_id": 11,
                "sort": 1,
                "file_name": "BureauGrot-BookItalic",
                "name": "Book Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1186,
                "family_id": 11,
                "sort": 3,
                "file_name": "BureauGrot-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 13,
        "family_name": "Bureau Grot Ultra",
        "google_family_name": null,
        "websafe_name": "BureauGrotUltra",
        "provider": "cargo",
        "foundry": "Font Bureau",
        "serif": "sans-serif",
        "axes": null,
        "sort": 25,
        "is_active": false,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 40,
                "family_id": 13,
                "sort": 0,
                "file_name": "BureauGrotUltra-Black",
                "name": "Black",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 12,
        "family_name": "Bureau Grot Condensed",
        "google_family_name": null,
        "websafe_name": "BureauGrotCondensed",
        "provider": "cargo",
        "foundry": "Font Bureau",
        "serif": "sans-serif",
        "axes": null,
        "sort": 26,
        "is_active": false,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 39,
                "family_id": 12,
                "sort": 0,
                "file_name": "BureauGrotCondensed-Book",
                "name": "Book",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 38,
                "family_id": 12,
                "sort": 1,
                "file_name": "BureauGrotCondensed-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1187,
                "family_id": 12,
                "sort": 1,
                "file_name": "BureauGrotCondensed-BoldItalic",
                "name": "Book Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1188,
                "family_id": 12,
                "sort": 3,
                "file_name": "BureauGrotCondensed-BookItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 199,
        "family_name": "Charter",
        "google_family_name": null,
        "websafe_name": "Charter",
        "provider": "cargo",
        "foundry": "Matthew Carter",
        "serif": "serif",
        "axes": null,
        "sort": 27,
        "is_active": true,
        "variable": false,
        "open_source": true,
        "license": "/* This is a copy of the Charter fonts which Bitstream contributed to the X consortium. This is the original notice included with the fonts: \n\n(c) Copyright 1989-1992, Bitstream Inc., Cambridge, MA. You are hereby granted permission under all Bitstream propriety rights to use, copy, modify, sublicense, sell, and redistribute the 4 Bitstream Charter (r) Type 1 outline fonts and the 4 Courier Type 1 outline fonts for any purpose and without restriction; provided, that this notice is left intact on all copies of such fonts and that Bitstream's trademark is acknowledged as shown below on all unmodified copies of the 4 Charter Type 1 fonts. BITSTREAM CHARTER is a registered trademark of Bitstream Inc. */",
        "variants": [
            {
                "vid": 550,
                "family_id": 199,
                "sort": 0,
                "file_name": "Charter-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 551,
                "family_id": 199,
                "sort": 1,
                "file_name": "Charter-Italic",
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 552,
                "family_id": 199,
                "sort": 2,
                "file_name": "Charter-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 553,
                "family_id": 199,
                "sort": 3,
                "file_name": "Charter-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 240,
        "family_name": "Chaumont Script",
        "google_family_name": null,
        "websafe_name": "ChaumontScript",
        "provider": "cargo",
        "foundry": "Alexandre Bassi, ANRT Type",
        "serif": "sans-serif",
        "axes": null,
        "sort": 28,
        "is_active": true,
        "variable": false,
        "open_source": true,
        "license": "/* Copyright 2021 Chaumont Script project authors (thomas.huot-marchand@anrt-type.fr) */",
        "variants": [
            {
                "vid": 824,
                "family_id": 240,
                "sort": 0,
                "file_name": "ChaumontScript-Regular",
                "name": "",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 96,
        "family_name": "Chivo",
        "google_family_name": "Chivo",
        "websafe_name": "Chivo",
        "provider": "google",
        "foundry": "Omnibus-Type",
        "serif": "sans-serif",
        "axes": null,
        "sort": 29,
        "is_active": false,
        "variable": false,
        "open_source": true,
        "license": null,
        "variants": [
            {
                "vid": 310,
                "family_id": 96,
                "sort": 0,
                "file_name": null,
                "name": "Regular",
                "google_variant_name": "400",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 311,
                "family_id": 96,
                "sort": 1,
                "file_name": null,
                "name": "Regular Italic",
                "google_variant_name": "400italic",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 312,
                "family_id": 96,
                "sort": 2,
                "file_name": null,
                "name": "Ultra-bold",
                "google_variant_name": "900",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 313,
                "family_id": 96,
                "sort": 3,
                "file_name": null,
                "name": "Ultra-bold Italic",
                "google_variant_name": "900italic",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 184,
        "family_name": "Courier",
        "google_family_name": null,
        "websafe_name": "Courier",
        "provider": "system",
        "foundry": "Howard Kettler",
        "serif": "monospace",
        "axes": null,
        "sort": 31,
        "is_active": true,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 474,
                "family_id": 184,
                "sort": 0,
                "file_name": null,
                "name": null,
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": "Courier, 'Courier New', monospace, 'Courier'",
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 475,
                "family_id": 184,
                "sort": 1,
                "file_name": null,
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": "Courier, 'Courier New', monospace, 'Courier Italic'",
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 476,
                "family_id": 184,
                "sort": 2,
                "file_name": null,
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": "Courier, 'Courier New', monospace, 'Courier Bold'",
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 477,
                "family_id": 184,
                "sort": 3,
                "file_name": null,
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": "Courier, 'Courier New', monospace, 'Courier Bold Italic'",
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 187,
        "family_name": "Courier New",
        "google_family_name": null,
        "websafe_name": "CourierNew",
        "provider": "system",
        "foundry": "Howard Kettler",
        "serif": "monospace",
        "axes": null,
        "sort": 32,
        "is_active": true,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 490,
                "family_id": 187,
                "sort": 0,
                "file_name": null,
                "name": null,
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": "'Courier New', 'Courier New', monospace, Courier New",
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 491,
                "family_id": 187,
                "sort": 1,
                "file_name": null,
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": "'Courier New', 'Courier New', monospace, Courier New Italic",
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 492,
                "family_id": 187,
                "sort": 2,
                "file_name": null,
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": "'Courier New', 'Courier New', monospace, Courier New Bold",
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 493,
                "family_id": 187,
                "sort": 3,
                "file_name": null,
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": "'Courier New', 'Courier New', monospace, Courier New Bold Italic",
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 255,
        "family_name": "Diatype Variable",
        "google_family_name": null,
        "websafe_name": "DiatypeVariable",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "sans-serif",
        "axes": [
            {
                "id": 0,
                "title": "Weight",
                "min": 200,
                "max": 1000,
                "step": 1,
                "css_fvs": "wght"
            },
            {
                "id": 1,
                "title": "Mono",
                "min": 0,
                "max": 1,
                "step": 0.01,
                "css_fvs": "MONO"
            },
            {
                "id": 2,
                "title": "Slant",
                "min": -12,
                "max": 0,
                "step": 0.1,
                "css_fvs": "slnt"
            }
        ],
        "sort": 34,
        "is_active": true,
        "variable": true,
        "open_source": false,
        "license": "/*\n * This CSS file has been generated and is served by Cargo Collective Inc\n * and is authorized to be used on Cargo Collective Inc only.\n *\n * This CSS resource incorporates links to font software which is\n * the valuable copyrighted property of Dinamo Typefaces. You may not\n * attempt to copy, install, redistribute, convert, modify or reverse\n * engineer this font software. Please contact Dinamo with any\n * questions: https://abcdinamo.com/\n */",
        "variants": [
            {
                "vid": 949,
                "family_id": 255,
                "sort": 0,
                "file_name": "Cargo-DiatypePlusVariable",
                "name": "Thin",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n2",
                "css_font_family": null,
                "css_font_fvs": "'wght' 200, 'slnt' 0, 'MONO' 0",
                "staff_pick": true
            },
            {
                "vid": 950,
                "family_id": 255,
                "sort": 1,
                "file_name": "Cargo-DiatypePlusVariable",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": "'wght' 300, 'slnt' 0, 'MONO' 0",
                "staff_pick": true
            },
            {
                "vid": 951,
                "family_id": 255,
                "sort": 2,
                "file_name": "Cargo-DiatypePlusVariable",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' 0, 'MONO' 0",
                "staff_pick": true
            },
            {
                "vid": 953,
                "family_id": 255,
                "sort": 4,
                "file_name": "Cargo-DiatypePlusVariable",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": "'wght' 500, 'slnt' 0, 'MONO' 0",
                "staff_pick": true
            },
            {
                "vid": 954,
                "family_id": 255,
                "sort": 5,
                "file_name": "Cargo-DiatypePlusVariable",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": "'wght' 700, 'slnt' 0, 'MONO' 0",
                "staff_pick": true
            },
            {
                "vid": 955,
                "family_id": 255,
                "sort": 6,
                "file_name": "Cargo-DiatypePlusVariable",
                "name": "Heavy",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n8",
                "css_font_family": null,
                "css_font_fvs": "'wght' 800, 'slnt' 0, 'MONO' 0",
                "staff_pick": true
            },
            {
                "vid": 956,
                "family_id": 255,
                "sort": 7,
                "file_name": "Cargo-DiatypePlusVariable",
                "name": "Black",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n9",
                "css_font_family": null,
                "css_font_fvs": "'wght' 900, 'slnt' 0, 'MONO' 0",
                "staff_pick": true
            },
            {
                "vid": 957,
                "family_id": 255,
                "sort": 8,
                "file_name": "Cargo-DiatypePlusVariable",
                "name": "Ultra",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n10",
                "css_font_family": null,
                "css_font_fvs": "'wght' 1000, 'slnt' 0, 'MONO' 0",
                "staff_pick": true
            },
            {
                "vid": 958,
                "family_id": 255,
                "sort": 9,
                "file_name": "Cargo-DiatypePlusVariable-Italic",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "200 1000",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' -12, 'MONO' 0",
                "staff_pick": true
            }
        ]
    },
    {
        "id": 283,
        "family_name": "Diatype Condensed Variable",
        "google_family_name": null,
        "websafe_name": "DiatypeCondensedVariable",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "sans-serif",
        "axes": [
            {
                "id": 0,
                "title": "Weight",
                "min": 200,
                "max": 700,
                "step": 1,
                "css_fvs": "wght"
            },
            {
                "id": 1,
                "title": "Width",
                "min": 50,
                "max": 100,
                "step": 1,
                "css_fvs": "wdth"
            },
            {
                "id": 2,
                "title": "Slant",
                "min": -12,
                "max": 0,
                "step": 0.1,
                "css_fvs": "slnt"
            }
        ],
        "sort": 35,
        "is_active": true,
        "variable": true,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 1143,
                "family_id": 283,
                "sort": 0,
                "file_name": "CargoDiatypeWidthsVariable",
                "name": "Thin",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n2",
                "css_font_family": null,
                "css_font_fvs": "'wght' 200, 'slnt' 0, 'wdth' 75",
                "staff_pick": false
            },
            {
                "vid": 1144,
                "family_id": 283,
                "sort": 1,
                "file_name": "CargoDiatypeWidthsVariable",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": "'wght' 300, 'slnt' 0, 'wdth' 75",
                "staff_pick": false
            },
            {
                "vid": 1145,
                "family_id": 283,
                "sort": 2,
                "file_name": "CargoDiatypeWidthsVariable",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' 0, 'wdth' 75",
                "staff_pick": true
            },
            {
                "vid": 1146,
                "family_id": 283,
                "sort": 3,
                "file_name": "CargoDiatypeWidthsVariable",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": "'wght' 500, 'slnt' 0, 'wdth' 75",
                "staff_pick": false
            },
            {
                "vid": 1147,
                "family_id": 283,
                "sort": 4,
                "file_name": "CargoDiatypeWidthsVariable",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": "'wght' 700, 'slnt' 0, 'wdth' 75",
                "staff_pick": false
            },
            {
                "vid": 1148,
                "family_id": 283,
                "sort": 5,
                "file_name": "CargoDiatypeItalicWidthsVariable",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "200 700",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' -12, 'wdth' 75",
                "staff_pick": false
            }
        ]
    },
    {
        "id": 284,
        "family_name": "Diatype Compressed Variable",
        "google_family_name": null,
        "websafe_name": "DiatypeCompressedVariable",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "sans-serif",
        "axes": [
            {
                "id": 0,
                "title": "Weight",
                "min": 200,
                "max": 700,
                "step": 1,
                "css_fvs": "wght"
            },
            {
                "id": 1,
                "title": "Width",
                "min": 50,
                "max": 100,
                "step": 1,
                "css_fvs": "wdth"
            },
            {
                "id": 2,
                "title": "Slant",
                "min": -12,
                "max": 0,
                "step": 0.1,
                "css_fvs": "slnt"
            }
        ],
        "sort": 36,
        "is_active": true,
        "variable": true,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 1149,
                "family_id": 284,
                "sort": 0,
                "file_name": "CargoDiatypeWidthsVariable",
                "name": "Thin",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n2",
                "css_font_family": null,
                "css_font_fvs": "'wght' 200, 'slnt' 0, 'wdth' 50",
                "staff_pick": false
            },
            {
                "vid": 1150,
                "family_id": 284,
                "sort": 1,
                "file_name": "CargoDiatypeWidthsVariable",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": "'wght' 300, 'slnt' 0, 'wdth' 50",
                "staff_pick": false
            },
            {
                "vid": 1151,
                "family_id": 284,
                "sort": 2,
                "file_name": "CargoDiatypeWidthsVariable",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' 0, 'wdth' 50",
                "staff_pick": true
            },
            {
                "vid": 1152,
                "family_id": 284,
                "sort": 3,
                "file_name": "CargoDiatypeWidthsVariable",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": "'wght' 500, 'slnt' 0, 'wdth' 50",
                "staff_pick": false
            },
            {
                "vid": 1153,
                "family_id": 284,
                "sort": 4,
                "file_name": "CargoDiatypeWidthsVariable",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": "'wght' 700, 'slnt' 0, 'wdth' 50",
                "staff_pick": false
            },
            {
                "vid": 1154,
                "family_id": 284,
                "sort": 5,
                "file_name": "CargoDiatypeItalicWidthsVariable",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "200 700",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' -12, 'wdth' 50",
                "staff_pick": false
            }
        ]
    },
    {
        "id": 256,
        "family_name": "Diatype Semi-Mono Variable",
        "google_family_name": null,
        "websafe_name": "DiatypeSemiMonoVariable",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "monospace",
        "axes": [
            {
                "id": 0,
                "title": "Weight",
                "min": 200,
                "max": 700,
                "step": 1,
                "css_fvs": "wght"
            },
            {
                "id": 1,
                "title": "Mono",
                "min": 0,
                "max": 1,
                "step": 0.01,
                "css_fvs": "MONO"
            },
            {
                "id": 2,
                "title": "Slant",
                "min": -12,
                "max": 0,
                "step": 0.1,
                "css_fvs": "slnt"
            }
        ],
        "sort": 37,
        "is_active": true,
        "variable": true,
        "open_source": false,
        "license": "/*\n * This CSS file has been generated and is served by Cargo Collective Inc\n * and is authorized to be used on Cargo Collective Inc only.\n *\n * This CSS resource incorporates links to font software which is\n * the valuable copyrighted property of Dinamo Typefaces. You may not\n * attempt to copy, install, redistribute, convert, modify or reverse\n * engineer this font software. Please contact Dinamo with any\n * questions: https://abcdinamo.com/\n */",
        "variants": [
            {
                "vid": 959,
                "family_id": 256,
                "sort": 0,
                "file_name": "Cargo-DiatypePlusVariable",
                "name": "Thin",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n2",
                "css_font_family": null,
                "css_font_fvs": "'wght' 200, 'slnt' 0, 'MONO' 0.5",
                "staff_pick": false
            },
            {
                "vid": 960,
                "family_id": 256,
                "sort": 1,
                "file_name": "Cargo-DiatypePlusVariable",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": "'wght' 300, 'slnt' 0, 'MONO' 0.5",
                "staff_pick": false
            },
            {
                "vid": 961,
                "family_id": 256,
                "sort": 2,
                "file_name": "Cargo-DiatypePlusVariable",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' 0, 'MONO' 0.5",
                "staff_pick": false
            },
            {
                "vid": 962,
                "family_id": 256,
                "sort": 3,
                "file_name": "Cargo-DiatypePlusVariable",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": "'wght' 500, 'slnt' 0, 'MONO' 0.5",
                "staff_pick": false
            },
            {
                "vid": 963,
                "family_id": 256,
                "sort": 4,
                "file_name": "Cargo-DiatypePlusVariable",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": "'wght' 700, 'slnt' 0, 'MONO' 0.5",
                "staff_pick": false
            },
            {
                "vid": 964,
                "family_id": 256,
                "sort": 5,
                "file_name": "Cargo-DiatypePlusVariable-Italic",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "200 700",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' -12, 'MONO' 0.5",
                "staff_pick": false
            }
        ]
    },
    {
        "id": 257,
        "family_name": "Diatype Mono Variable",
        "google_family_name": null,
        "websafe_name": "DiatypeMonoVariable",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "monospace",
        "axes": [
            {
                "id": 0,
                "title": "Weight",
                "min": 200,
                "max": 700,
                "step": 1,
                "css_fvs": "wght"
            },
            {
                "id": 1,
                "title": "Mono",
                "min": 0,
                "max": 1,
                "step": 0.01,
                "css_fvs": "MONO"
            },
            {
                "id": 2,
                "title": "Slant",
                "min": -12,
                "max": 0,
                "step": 0.1,
                "css_fvs": "slnt"
            }
        ],
        "sort": 38,
        "is_active": true,
        "variable": true,
        "open_source": false,
        "license": "/*\n * This CSS file has been generated and is served by Cargo Collective Inc\n * and is authorized to be used on Cargo Collective Inc only.\n *\n * This CSS resource incorporates links to font software which is\n * the valuable copyrighted property of Dinamo Typefaces. You may not\n * attempt to copy, install, redistribute, convert, modify or reverse\n * engineer this font software. Please contact Dinamo with any\n * questions: https://abcdinamo.com/\n */",
        "variants": [
            {
                "vid": 965,
                "family_id": 257,
                "sort": 0,
                "file_name": "Cargo-DiatypePlusVariable",
                "name": "Thin",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n2",
                "css_font_family": null,
                "css_font_fvs": "'wght' 200, 'slnt' 0, 'MONO' 1",
                "staff_pick": true
            },
            {
                "vid": 966,
                "family_id": 257,
                "sort": 1,
                "file_name": "Cargo-DiatypePlusVariable",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": "'wght' 300, 'slnt' 0, 'MONO' 1",
                "staff_pick": true
            },
            {
                "vid": 967,
                "family_id": 257,
                "sort": 2,
                "file_name": "Cargo-DiatypePlusVariable",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' 0, 'MONO' 1",
                "staff_pick": true
            },
            {
                "vid": 968,
                "family_id": 257,
                "sort": 3,
                "file_name": "Cargo-DiatypePlusVariable",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": "'wght' 500, 'slnt' 0, 'MONO' 1",
                "staff_pick": true
            },
            {
                "vid": 969,
                "family_id": 257,
                "sort": 4,
                "file_name": "Cargo-DiatypePlusVariable",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 700",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": "'wght' 700, 'slnt' 0, 'MONO' 1",
                "staff_pick": true
            },
            {
                "vid": 970,
                "family_id": 257,
                "sort": 5,
                "file_name": "Cargo-DiatypePlusVariable-Italic",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "200 700",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' -12, 'MONO' 1",
                "staff_pick": true
            }
        ]
    },
    {
        "id": 225,
        "family_name": "Diatype",
        "google_family_name": null,
        "websafe_name": "Diatype",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "sans-serif",
        "axes": null,
        "sort": 39,
        "is_active": false,
        "variable": false,
        "open_source": false,
        "license": "/*\n * This CSS file has been generated and is served by Cargo Collective Inc\n * and is authorized to be used on Cargo Collective Inc only.\n *\n * This CSS resource incorporates links to font software which is\n * the valuable copyrighted property of Dinamo Typefaces. You may not\n * attempt to copy, install, redistribute, convert, modify or reverse\n * engineer this font software. Please contact Dinamo with any\n * questions: https://abcdinamo.com/\n */",
        "variants": [
            {
                "vid": 678,
                "family_id": 225,
                "sort": 0,
                "file_name": "CargoDiatype-Thin",
                "name": "Thin",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200",
                "css_font_fvd": "n2",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 679,
                "family_id": 225,
                "sort": 1,
                "file_name": "CargoDiatype-ThinItalic",
                "name": "Thin Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "200",
                "css_font_fvd": "i2",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 680,
                "family_id": 225,
                "sort": 2,
                "file_name": "CargoDiatype-Light",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 681,
                "family_id": 225,
                "sort": 3,
                "file_name": "CargoDiatype-LightItalic",
                "name": "Light Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "300",
                "css_font_fvd": "i3",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 682,
                "family_id": 225,
                "sort": 4,
                "file_name": "CargoDiatype-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "400",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": true
            },
            {
                "vid": 683,
                "family_id": 225,
                "sort": 5,
                "file_name": "CargoDiatype-RegularItalic",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "400",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 684,
                "family_id": 225,
                "sort": 6,
                "file_name": "CargoDiatype-Medium",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "500",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 685,
                "family_id": 225,
                "sort": 7,
                "file_name": "CargoDiatype-MediumItalic",
                "name": "Medium Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "500",
                "css_font_fvd": "i5",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 686,
                "family_id": 225,
                "sort": 8,
                "file_name": "CargoDiatype-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "700",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 687,
                "family_id": 225,
                "sort": 9,
                "file_name": "CargoDiatype-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "700",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 223,
        "family_name": "Diatype Mono",
        "google_family_name": null,
        "websafe_name": "DiatypeMono",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "monospace",
        "axes": null,
        "sort": 40,
        "is_active": false,
        "variable": false,
        "open_source": false,
        "license": "/*\n * This CSS file has been generated and is served by Cargo Collective Inc\n * and is authorized to be used on Cargo Collective Inc only.\n *\n * This CSS resource incorporates links to font software which is\n * the valuable copyrighted property of Dinamo Typefaces. You may not\n * attempt to copy, install, redistribute, convert, modify or reverse\n * engineer this font software. Please contact Dinamo with any\n * questions: https://abcdinamo.com/\n */",
        "variants": [
            {
                "vid": 688,
                "family_id": 223,
                "sort": 0,
                "file_name": "CargoDiatypeMono-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "400",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": true
            }
        ]
    },
    {
        "id": 224,
        "family_name": "Diatype Semi-Mono",
        "google_family_name": null,
        "websafe_name": "DiatypeSemiMono",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "monospace",
        "axes": null,
        "sort": 41,
        "is_active": false,
        "variable": false,
        "open_source": false,
        "license": "/*\n * This CSS file has been generated and is served by Cargo Collective Inc\n * and is authorized to be used on Cargo Collective Inc only.\n *\n * This CSS resource incorporates links to font software which is\n * the valuable copyrighted property of Dinamo Typefaces. You may not\n * attempt to copy, install, redistribute, convert, modify or reverse\n * engineer this font software. Please contact Dinamo with any\n * questions: https://abcdinamo.com/\n */",
        "variants": [
            {
                "vid": 689,
                "family_id": 224,
                "sort": 0,
                "file_name": "CargoDiatypeSemi-Mono-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "400",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 97,
        "family_name": "Darker Grotesque",
        "google_family_name": "Darker Grotesque",
        "websafe_name": "DarkerGrotesque",
        "provider": "google",
        "foundry": "Gabriel Lam",
        "serif": "sans-serif",
        "axes": null,
        "sort": 48,
        "is_active": false,
        "variable": false,
        "open_source": true,
        "license": null,
        "variants": [
            {
                "vid": 314,
                "family_id": 97,
                "sort": 0,
                "file_name": null,
                "name": "Medium",
                "google_variant_name": "500",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 316,
                "family_id": 97,
                "sort": 2,
                "file_name": null,
                "name": "Bold",
                "google_variant_name": "700",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 15,
        "family_name": "Dolly Pro",
        "google_family_name": null,
        "websafe_name": "DollyPro",
        "provider": "cargo",
        "foundry": "Underware",
        "serif": "serif",
        "axes": null,
        "sort": 49,
        "is_active": true,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 45,
                "family_id": 15,
                "sort": 0,
                "file_name": "DollyPro-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 46,
                "family_id": 15,
                "sort": 1,
                "file_name": "DollyPro-RegularItalic",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 47,
                "family_id": 15,
                "sort": 2,
                "file_name": "DollyPro-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 16,
        "family_name": "Epistle",
        "google_family_name": null,
        "websafe_name": "Epistle",
        "provider": "cargo",
        "foundry": "Eli Heuer",
        "serif": "serif",
        "axes": null,
        "sort": 50,
        "is_active": false,
        "variable": false,
        "open_source": true,
        "license": "/*\n * Epistle by Eli Heuer\n * Copyright 2018 The Wilmette Project Authors (elih@protonmail.com)\n */",
        "variants": [
            {
                "vid": 48,
                "family_id": 16,
                "sort": 0,
                "file_name": "Epistle-Regular",
                "name": "",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 248,
        "family_name": "Favorit Variable",
        "google_family_name": null,
        "websafe_name": "FavoritVariable",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "sans-serif",
        "axes": [
            {
                "id": 0,
                "title": "Weight",
                "min": 300,
                "max": 700,
                "step": 1,
                "css_fvs": "wght"
            },
            {
                "id": 1,
                "title": "Slant",
                "min": -12,
                "max": 0,
                "step": 0.1,
                "css_fvs": "slnt"
            }
        ],
        "sort": 51,
        "is_active": true,
        "variable": true,
        "open_source": false,
        "license": "/*\n * This CSS file has been generated and is served by Cargo Collective Inc\n * and is authorized to be used on Cargo Collective Inc only.\n *\n * This CSS resource incorporates links to font software which is\n * the valuable copyrighted property of Dinamo Typefaces. You may not\n * attempt to copy, install, redistribute, convert, modify or reverse\n * engineer this font software. Please contact Dinamo with any\n * questions: https://abcdinamo.com/\n */",
        "variants": [
            {
                "vid": 903,
                "family_id": 248,
                "sort": 0,
                "file_name": "CargoFavoritVariable",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300 700",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": "'wght' 300, 'slnt' 0",
                "staff_pick": true
            },
            {
                "vid": 904,
                "family_id": 248,
                "sort": 1,
                "file_name": "CargoFavoritVariable",
                "name": "Book",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300 700",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": "'wght' 350, 'slnt' 0",
                "staff_pick": true
            },
            {
                "vid": 905,
                "family_id": 248,
                "sort": 2,
                "file_name": "CargoFavoritVariable",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300 700",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' 0",
                "staff_pick": true
            },
            {
                "vid": 906,
                "family_id": 248,
                "sort": 3,
                "file_name": "CargoFavoritVariable",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300 700",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": "'wght' 500, 'slnt' 0",
                "staff_pick": true
            },
            {
                "vid": 907,
                "family_id": 248,
                "sort": 4,
                "file_name": "CargoFavoritVariable",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300 700",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": "'wght' 700, 'slnt' 0",
                "staff_pick": true
            },
            {
                "vid": 915,
                "family_id": 248,
                "sort": 5,
                "file_name": "CargoFavoritItalicVariable",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "300 700",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' -12",
                "staff_pick": true
            }
        ]
    },
    {
        "id": 249,
        "family_name": "Favorit Mono Variable",
        "google_family_name": null,
        "websafe_name": "FavoritMonoVariable",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "monospace",
        "axes": [
            {
                "id": 0,
                "title": "Weight",
                "min": 300,
                "max": 700,
                "step": 1,
                "css_fvs": "wght"
            },
            {
                "id": 1,
                "title": "Slant",
                "min": -12,
                "max": 0,
                "step": 0.1,
                "css_fvs": "slnt"
            }
        ],
        "sort": 52,
        "is_active": true,
        "variable": true,
        "open_source": false,
        "license": "/*\n * This CSS file has been generated and is served by Cargo Collective Inc\n * and is authorized to be used on Cargo Collective Inc only.\n *\n * This CSS resource incorporates links to font software which is\n * the valuable copyrighted property of Dinamo Typefaces. You may not\n * attempt to copy, install, redistribute, convert, modify or reverse\n * engineer this font software. Please contact Dinamo with any\n * questions: https://abcdinamo.com/\n */",
        "variants": [
            {
                "vid": 908,
                "family_id": 249,
                "sort": 0,
                "file_name": "CargoFavoritMonoVariable",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300 700",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": "'wght' 300, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 909,
                "family_id": 249,
                "sort": 1,
                "file_name": "CargoFavoritMonoVariable",
                "name": "Book",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300 700",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": "'wght' 350, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 910,
                "family_id": 249,
                "sort": 2,
                "file_name": "CargoFavoritMonoVariable",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300 700",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 911,
                "family_id": 249,
                "sort": 3,
                "file_name": "CargoFavoritMonoVariable",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300 700",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": "'wght' 500, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 912,
                "family_id": 249,
                "sort": 4,
                "file_name": "CargoFavoritMonoVariable",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300 700",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": "'wght' 700, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 916,
                "family_id": 249,
                "sort": 5,
                "file_name": "CargoFavoritMonoItalicVariable",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "300 700",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' -12",
                "staff_pick": false
            }
        ]
    },
    {
        "id": 222,
        "family_name": "Favorit",
        "google_family_name": null,
        "websafe_name": "Favorit",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "sans-serif",
        "axes": null,
        "sort": 53,
        "is_active": false,
        "variable": false,
        "open_source": false,
        "license": "/*\n * This CSS file has been generated and is served by Cargo Collective Inc\n * and is authorized to be used on Cargo Collective Inc only.\n *\n * This CSS resource incorporates links to font software which is\n * the valuable copyrighted property of Dinamo Typefaces. You may not\n * attempt to copy, install, redistribute, convert, modify or reverse\n * engineer this font software. Please contact Dinamo with any\n * questions: https://abcdinamo.com/\n */",
        "variants": [
            {
                "vid": 690,
                "family_id": 222,
                "sort": 0,
                "file_name": "CargoFavorit-Light",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200",
                "css_font_fvd": "n2",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 691,
                "family_id": 222,
                "sort": 1,
                "file_name": "CargoFavorit-LightItalic",
                "name": "Light Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "200",
                "css_font_fvd": "i2",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 692,
                "family_id": 222,
                "sort": 2,
                "file_name": "CargoFavorit-Book",
                "name": "Book",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 693,
                "family_id": 222,
                "sort": 3,
                "file_name": "CargoFavorit-BookItalic",
                "name": "Book Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "300",
                "css_font_fvd": "i3",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 694,
                "family_id": 222,
                "sort": 4,
                "file_name": "CargoFavorit-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "400",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": true
            },
            {
                "vid": 695,
                "family_id": 222,
                "sort": 5,
                "file_name": "CargoFavorit-RegularItalic",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "400",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 696,
                "family_id": 222,
                "sort": 6,
                "file_name": "CargoFavorit-Medium",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "500",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 697,
                "family_id": 222,
                "sort": 7,
                "file_name": "CargoFavorit-MediumItalic",
                "name": "Medium Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "500",
                "css_font_fvd": "i5",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 698,
                "family_id": 222,
                "sort": 8,
                "file_name": "CargoFavorit-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "700",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 699,
                "family_id": 222,
                "sort": 9,
                "file_name": "CargoFavorit-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "700",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 226,
        "family_name": "Favorit Mono",
        "google_family_name": null,
        "websafe_name": "FavoritMono",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "monospace",
        "axes": null,
        "sort": 54,
        "is_active": false,
        "variable": false,
        "open_source": false,
        "license": "/*\n * This CSS file has been generated and is served by Cargo Collective Inc\n * and is authorized to be used on Cargo Collective Inc only.\n *\n * This CSS resource incorporates links to font software which is\n * the valuable copyrighted property of Dinamo Typefaces. You may not\n * attempt to copy, install, redistribute, convert, modify or reverse\n * engineer this font software. Please contact Dinamo with any\n * questions: https://abcdinamo.com/\n */",
        "variants": [
            {
                "vid": 701,
                "family_id": 226,
                "sort": 0,
                "file_name": "CargoFavoritMono-Light",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200",
                "css_font_fvd": "n2",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 702,
                "family_id": 226,
                "sort": 1,
                "file_name": "CargoFavoritMono-LightItalic",
                "name": "Light Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "200",
                "css_font_fvd": "i2",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 703,
                "family_id": 226,
                "sort": 2,
                "file_name": "CargoFavoritMono-Book",
                "name": "Book",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 704,
                "family_id": 226,
                "sort": 3,
                "file_name": "CargoFavoritMono-BookItalic",
                "name": "Book Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "300",
                "css_font_fvd": "i3",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 700,
                "family_id": 226,
                "sort": 4,
                "file_name": "CargoFavoritMono-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "400",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": true
            },
            {
                "vid": 705,
                "family_id": 226,
                "sort": 5,
                "file_name": "CargoFavoritMono-RegularItalic",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "400",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 706,
                "family_id": 226,
                "sort": 6,
                "file_name": "CargoFavoritMono-Medium",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "500",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 707,
                "family_id": 226,
                "sort": 7,
                "file_name": "CargoFavoritMono-MediumItalic",
                "name": "Medium Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "500",
                "css_font_fvd": "i5",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 708,
                "family_id": 226,
                "sort": 8,
                "file_name": "CargoFavoritMono-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "700",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 709,
                "family_id": 226,
                "sort": 9,
                "file_name": "CargoFavoritMono-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "700",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 100,
        "family_name": "Fjalla One",
        "google_family_name": "Fjalla One",
        "websafe_name": "FjallaOne",
        "provider": "google",
        "foundry": "Sorkin Type",
        "serif": "sans-serif",
        "axes": null,
        "sort": 55,
        "is_active": false,
        "variable": false,
        "open_source": true,
        "license": null,
        "variants": [
            {
                "vid": 324,
                "family_id": 100,
                "sort": 0,
                "file_name": null,
                "name": "Regular",
                "google_variant_name": "400",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 18,
        "family_name": "Fort",
        "google_family_name": null,
        "websafe_name": "Fort",
        "provider": "cargo",
        "foundry": "Jeremy Mickel",
        "serif": "sans-serif",
        "axes": null,
        "sort": 57,
        "is_active": false,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 61,
                "family_id": 18,
                "sort": 0,
                "file_name": "Fort-Book",
                "name": "Book",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 62,
                "family_id": 18,
                "sort": 1,
                "file_name": "Fort-BookItalic",
                "name": "Book Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 59,
                "family_id": 18,
                "sort": 2,
                "file_name": "Fort-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 60,
                "family_id": 18,
                "sort": 3,
                "file_name": "Fort-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 19,
        "family_name": "Fort Extrabold",
        "google_family_name": null,
        "websafe_name": "FortExtrabold",
        "provider": "cargo",
        "foundry": "Jeremy Mickel",
        "serif": "sans-serif",
        "axes": null,
        "sort": 58,
        "is_active": false,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 63,
                "family_id": 19,
                "sort": 0,
                "file_name": "FortExtrabold-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 64,
                "family_id": 19,
                "sort": 1,
                "file_name": "FortExtrabold-Italic",
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 104,
        "family_name": "Freight Big",
        "google_family_name": null,
        "websafe_name": "FreightBig",
        "provider": "cargo",
        "foundry": "GarageFonts",
        "serif": "serif",
        "axes": null,
        "sort": 60,
        "is_active": true,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 326,
                "family_id": 104,
                "sort": 0,
                "file_name": "FreightBig-Light",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200",
                "css_font_fvd": "n2",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 327,
                "family_id": 104,
                "sort": 1,
                "file_name": "FreightBig-LightItalic",
                "name": "Light Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "200",
                "css_font_fvd": "i2",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 328,
                "family_id": 104,
                "sort": 2,
                "file_name": "FreightBig-Book",
                "name": "Book",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 329,
                "family_id": 104,
                "sort": 3,
                "file_name": "FreightBig-BookItalic",
                "name": "Book Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 330,
                "family_id": 104,
                "sort": 4,
                "file_name": "FreightBig-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 331,
                "family_id": 104,
                "sort": 5,
                "file_name": "FreightBig-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 21,
        "family_name": "Freight Text",
        "google_family_name": null,
        "websafe_name": "FreightText",
        "provider": "cargo",
        "foundry": "GarageFonts",
        "serif": "serif",
        "axes": null,
        "sort": 61,
        "is_active": true,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 73,
                "family_id": 21,
                "sort": 0,
                "file_name": "FreightText-Book",
                "name": "Book",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 74,
                "family_id": 21,
                "sort": 1,
                "file_name": "FreightText-BookItalic",
                "name": "Book Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 71,
                "family_id": 21,
                "sort": 2,
                "file_name": "FreightText-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 72,
                "family_id": 21,
                "sort": 3,
                "file_name": "FreightText-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 275,
        "family_name": "Gaisyr",
        "google_family_name": null,
        "websafe_name": "Gaisyr",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "serif",
        "axes": null,
        "sort": 62,
        "is_active": true,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 1069,
                "family_id": 275,
                "sort": 0,
                "file_name": "CargoGaisyr-Thin",
                "name": "Thin",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200",
                "css_font_fvd": "n2",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1077,
                "family_id": 275,
                "sort": 1,
                "file_name": "CargoGaisyr-ThinItalic",
                "name": "Thin Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "200",
                "css_font_fvd": "i2",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1070,
                "family_id": 275,
                "sort": 2,
                "file_name": "CargoGaisyr-Light",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1078,
                "family_id": 275,
                "sort": 3,
                "file_name": "CargoGaisyr-LightItalic",
                "name": "Light Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "300",
                "css_font_fvd": "i3",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1071,
                "family_id": 275,
                "sort": 4,
                "file_name": "CargoGaisyr-Book",
                "name": "Book",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "350",
                "css_font_fvd": "n35",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1079,
                "family_id": 275,
                "sort": 5,
                "file_name": "CargoGaisyr-BookItalic",
                "name": "Book Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "350",
                "css_font_fvd": "i35",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1072,
                "family_id": 275,
                "sort": 6,
                "file_name": "CargoGaisyr-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "400",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": true
            },
            {
                "vid": 1076,
                "family_id": 275,
                "sort": 7,
                "file_name": "CargoGaisyr-RegularItalic",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "400",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1073,
                "family_id": 275,
                "sort": 8,
                "file_name": "CargoGaisyr-Medium",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "500",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1080,
                "family_id": 275,
                "sort": 9,
                "file_name": "CargoGaisyr-MediumItalic",
                "name": "Medium Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "500",
                "css_font_fvd": "i5",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1074,
                "family_id": 275,
                "sort": 10,
                "file_name": "CargoGaisyr-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "700",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1081,
                "family_id": 275,
                "sort": 11,
                "file_name": "CargoGaisyr-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "700",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1075,
                "family_id": 275,
                "sort": 12,
                "file_name": "CargoGaisyr-Black",
                "name": "Black",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "900",
                "css_font_fvd": "n9",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1082,
                "family_id": 275,
                "sort": 13,
                "file_name": "CargoGaisyr-BlackItalic",
                "name": "Black Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "900",
                "css_font_fvd": "i9",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 277,
        "family_name": "Gaisyr Semi-Mono",
        "google_family_name": null,
        "websafe_name": "GaisyrSemiMono",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "monospace",
        "axes": null,
        "sort": 63,
        "is_active": true,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 1097,
                "family_id": 277,
                "sort": 0,
                "file_name": "CargoGaisyrSemi-Mono-Thin",
                "name": "Thin",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200",
                "css_font_fvd": "n2",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1098,
                "family_id": 277,
                "sort": 1,
                "file_name": "CargoGaisyrSemi-Mono-Light",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1099,
                "family_id": 277,
                "sort": 2,
                "file_name": "CargoGaisyrSemi-Mono-Book",
                "name": "Book",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "350",
                "css_font_fvd": "n35",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1100,
                "family_id": 277,
                "sort": 3,
                "file_name": "CargoGaisyrSemi-Mono-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "400",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1101,
                "family_id": 277,
                "sort": 4,
                "file_name": "CargoGaisyrSemi-Mono-Medium",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "500",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1102,
                "family_id": 277,
                "sort": 5,
                "file_name": "CargoGaisyrSemi-Mono-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "700",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1103,
                "family_id": 277,
                "sort": 6,
                "file_name": "CargoGaisyrSemi-Mono-Black",
                "name": "Black",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "900",
                "css_font_fvd": "n9",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 276,
        "family_name": "Gaisyr Mono",
        "google_family_name": null,
        "websafe_name": "GaisyrMono",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "monospace",
        "axes": null,
        "sort": 64,
        "is_active": true,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 1083,
                "family_id": 276,
                "sort": 0,
                "file_name": "CargoGaisyrMono-Thin",
                "name": "Thin",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200",
                "css_font_fvd": "n2",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1085,
                "family_id": 276,
                "sort": 2,
                "file_name": "CargoGaisyrMono-Light",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1087,
                "family_id": 276,
                "sort": 4,
                "file_name": "CargoGaisyrMono-Book",
                "name": "Book",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "350",
                "css_font_fvd": "n35",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1089,
                "family_id": 276,
                "sort": 6,
                "file_name": "CargoGaisyrMono-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "400",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1091,
                "family_id": 276,
                "sort": 8,
                "file_name": "CargoGaisyrMono-Medium",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "500",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1093,
                "family_id": 276,
                "sort": 10,
                "file_name": "CargoGaisyrMono-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "700",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1095,
                "family_id": 276,
                "sort": 12,
                "file_name": "CargoGaisyrMono-Black",
                "name": "Black",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "900",
                "css_font_fvd": "n9",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 22,
        "family_name": "Garage Gothic",
        "google_family_name": null,
        "websafe_name": "GarageGothic",
        "provider": "cargo",
        "foundry": "Frere-Jones Type",
        "serif": "sans-serif",
        "axes": null,
        "sort": 65,
        "is_active": true,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 77,
                "family_id": 22,
                "sort": 0,
                "file_name": "GarageGothic-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 76,
                "family_id": 22,
                "sort": 1,
                "file_name": "GarageGothic-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 75,
                "family_id": 22,
                "sort": 2,
                "file_name": "GarageGothic-Black",
                "name": "Black",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "900",
                "css_font_fvd": "n9",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 23,
        "family_name": "Garcia Libre",
        "google_family_name": null,
        "websafe_name": "GarciaLibre",
        "provider": "cargo",
        "foundry": "Anton Moglia",
        "serif": "sans-serif",
        "axes": null,
        "sort": 66,
        "is_active": false,
        "variable": false,
        "open_source": true,
        "license": "/*\n * Garcia Libre is a sans-serif font by Anton Moglia (http://www.moglia.fr/)\n */",
        "variants": [
            {
                "vid": 78,
                "family_id": 23,
                "sort": 0,
                "file_name": "GarciaLibre",
                "name": "",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 118,
        "family_name": "EB Garamond",
        "google_family_name": "EB Garamond",
        "websafe_name": "EBGaramond",
        "provider": "google",
        "foundry": "Georg Duffner",
        "serif": "serif",
        "axes": null,
        "sort": 67,
        "is_active": true,
        "variable": false,
        "open_source": true,
        "license": null,
        "variants": [
            {
                "vid": 376,
                "family_id": 118,
                "sort": 0,
                "file_name": null,
                "name": "Regular",
                "google_variant_name": "400",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 377,
                "family_id": 118,
                "sort": 1,
                "file_name": null,
                "name": "Regular Italic",
                "google_variant_name": "400italic",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 378,
                "family_id": 118,
                "sort": 2,
                "file_name": null,
                "name": "Medium",
                "google_variant_name": "500",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 379,
                "family_id": 118,
                "sort": 3,
                "file_name": null,
                "name": "Medium Italic",
                "google_variant_name": "500italic",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 380,
                "family_id": 118,
                "sort": 4,
                "file_name": null,
                "name": "Bold",
                "google_variant_name": "700",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 381,
                "family_id": 118,
                "sort": 5,
                "file_name": null,
                "name": "Bold Italic",
                "google_variant_name": "700italic",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 382,
                "family_id": 118,
                "sort": 6,
                "file_name": null,
                "name": "Extra Bold",
                "google_variant_name": "800",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 383,
                "family_id": 118,
                "sort": 7,
                "file_name": null,
                "name": "Extra Bold Italic",
                "google_variant_name": "800italic",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 280,
        "family_name": "Gramercy Variable",
        "google_family_name": null,
        "websafe_name": "GramercyVariable",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "serif",
        "axes": [
            {
                "id": 0,
                "title": "Weight",
                "min": 200,
                "max": 1000,
                "step": 1,
                "css_fvs": "wght"
            },
            {
                "id": 1,
                "title": "Optical Size",
                "min": 12,
                "max": 72,
                "step": 1,
                "css_fvs": "opsz"
            }
        ],
        "sort": 68,
        "is_active": true,
        "variable": true,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 1116,
                "family_id": 280,
                "sort": 0,
                "file_name": "CargoGramercyVariable",
                "name": "Thin",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n2",
                "css_font_family": null,
                "css_font_fvs": "'wght' 200, 'opsz' 12",
                "staff_pick": false
            },
            {
                "vid": 1117,
                "family_id": 280,
                "sort": 1,
                "file_name": "CargoGramercyVariable",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": "'wght' 300, 'opsz' 12",
                "staff_pick": false
            },
            {
                "vid": 1118,
                "family_id": 280,
                "sort": 2,
                "file_name": "CargoGramercyVariable",
                "name": "Book",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n35",
                "css_font_family": null,
                "css_font_fvs": "'wght' 350, 'opsz' 12",
                "staff_pick": false
            },
            {
                "vid": 1119,
                "family_id": 280,
                "sort": 3,
                "file_name": "CargoGramercyVariable",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'opsz' 12",
                "staff_pick": true
            },
            {
                "vid": 1120,
                "family_id": 280,
                "sort": 4,
                "file_name": "CargoGramercyVariable",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": "'wght' 500, 'opsz' 12",
                "staff_pick": false
            },
            {
                "vid": 1121,
                "family_id": 280,
                "sort": 5,
                "file_name": "CargoGramercyVariable",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": "'wght' 700, 'opsz' 12",
                "staff_pick": false
            },
            {
                "vid": 1122,
                "family_id": 280,
                "sort": 6,
                "file_name": "CargoGramercyVariable",
                "name": "Black",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n9",
                "css_font_family": null,
                "css_font_fvs": "'wght' 900, 'opsz' 12",
                "staff_pick": false
            },
            {
                "vid": 1123,
                "family_id": 280,
                "sort": 7,
                "file_name": "CargoGramercyVariable",
                "name": "Super",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n10",
                "css_font_family": null,
                "css_font_fvs": "'wght' 1000, 'opsz' 12",
                "staff_pick": false
            },
            {
                "vid": 1124,
                "family_id": 280,
                "sort": 8,
                "file_name": "CargoGramercyItalicVariable",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'opsz' 12",
                "staff_pick": false
            }
        ]
    },
    {
        "id": 281,
        "family_name": "Gramercy Fine Variable",
        "google_family_name": null,
        "websafe_name": "GramercyFineVariable",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "serif",
        "axes": [
            {
                "id": 0,
                "title": "Weight",
                "min": 200,
                "max": 1000,
                "step": 1,
                "css_fvs": "wght"
            },
            {
                "id": 1,
                "title": "Optical Size",
                "min": 12,
                "max": 72,
                "step": 1,
                "css_fvs": "opsz"
            }
        ],
        "sort": 69,
        "is_active": true,
        "variable": true,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 1125,
                "family_id": 281,
                "sort": 0,
                "file_name": "CargoGramercyVariable",
                "name": "Thin",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n2",
                "css_font_family": null,
                "css_font_fvs": "'wght' 200, 'opsz' 42",
                "staff_pick": false
            },
            {
                "vid": 1126,
                "family_id": 281,
                "sort": 1,
                "file_name": "CargoGramercyVariable",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": "'wght' 300, 'opsz' 42",
                "staff_pick": false
            },
            {
                "vid": 1127,
                "family_id": 281,
                "sort": 2,
                "file_name": "CargoGramercyVariable",
                "name": "Book",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n35",
                "css_font_family": null,
                "css_font_fvs": "'wght' 350, 'opsz' 42",
                "staff_pick": false
            },
            {
                "vid": 1128,
                "family_id": 281,
                "sort": 3,
                "file_name": "CargoGramercyVariable",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'opsz' 42",
                "staff_pick": false
            },
            {
                "vid": 1129,
                "family_id": 281,
                "sort": 4,
                "file_name": "CargoGramercyVariable",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": "'wght' 500, 'opsz' 42",
                "staff_pick": false
            },
            {
                "vid": 1130,
                "family_id": 281,
                "sort": 5,
                "file_name": "CargoGramercyVariable",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": "'wght' 700, 'opsz' 42",
                "staff_pick": false
            },
            {
                "vid": 1131,
                "family_id": 281,
                "sort": 6,
                "file_name": "CargoGramercyVariable",
                "name": "Black",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n9",
                "css_font_family": null,
                "css_font_fvs": "'wght' 900, 'opsz' 42",
                "staff_pick": false
            },
            {
                "vid": 1132,
                "family_id": 281,
                "sort": 7,
                "file_name": "CargoGramercyVariable",
                "name": "Super",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n10",
                "css_font_family": null,
                "css_font_fvs": "'wght' 1000, 'opsz' 42",
                "staff_pick": false
            },
            {
                "vid": 1133,
                "family_id": 281,
                "sort": 8,
                "file_name": "CargoGramercyItalicVariable",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'opsz' 42",
                "staff_pick": false
            }
        ]
    },
    {
        "id": 282,
        "family_name": "Gramercy Display Variable",
        "google_family_name": null,
        "websafe_name": "GramercyDisplayVariable",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "serif",
        "axes": [
            {
                "id": 0,
                "title": "Weight",
                "min": 200,
                "max": 1000,
                "step": 1,
                "css_fvs": "wght"
            },
            {
                "id": 1,
                "title": "Optical Size",
                "min": 12,
                "max": 72,
                "step": 1,
                "css_fvs": "opsz"
            }
        ],
        "sort": 70,
        "is_active": true,
        "variable": true,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 1134,
                "family_id": 282,
                "sort": 0,
                "file_name": "CargoGramercyVariable",
                "name": "Thin",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n2",
                "css_font_family": null,
                "css_font_fvs": "'wght' 200, 'opsz' 72",
                "staff_pick": false
            },
            {
                "vid": 1135,
                "family_id": 282,
                "sort": 1,
                "file_name": "CargoGramercyVariable",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": "'wght' 300, 'opsz' 72",
                "staff_pick": false
            },
            {
                "vid": 1136,
                "family_id": 282,
                "sort": 2,
                "file_name": "CargoGramercyVariable",
                "name": "Book",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n35",
                "css_font_family": null,
                "css_font_fvs": "'wght' 350, 'opsz' 72",
                "staff_pick": false
            },
            {
                "vid": 1137,
                "family_id": 282,
                "sort": 3,
                "file_name": "CargoGramercyVariable",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'opsz' 72",
                "staff_pick": false
            },
            {
                "vid": 1138,
                "family_id": 282,
                "sort": 4,
                "file_name": "CargoGramercyVariable",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": "'wght' 500, 'opsz' 72",
                "staff_pick": false
            },
            {
                "vid": 1139,
                "family_id": 282,
                "sort": 5,
                "file_name": "CargoGramercyVariable",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": "'wght' 700, 'opsz' 72",
                "staff_pick": false
            },
            {
                "vid": 1140,
                "family_id": 282,
                "sort": 6,
                "file_name": "CargoGramercyVariable",
                "name": "Black",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n9",
                "css_font_family": null,
                "css_font_fvs": "'wght' 900, 'opsz' 72",
                "staff_pick": false
            },
            {
                "vid": 1141,
                "family_id": 282,
                "sort": 7,
                "file_name": "CargoGramercyVariable",
                "name": "Super",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n10",
                "css_font_family": null,
                "css_font_fvs": "'wght' 1000, 'opsz' 72",
                "staff_pick": false
            },
            {
                "vid": 1142,
                "family_id": 282,
                "sort": 8,
                "file_name": "CargoGramercyItalicVariable",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'opsz' 72",
                "staff_pick": false
            }
        ]
    },
    {
        "id": 244,
        "family_name": "Gravity Variable",
        "google_family_name": null,
        "websafe_name": "GravityVariable",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "sans-serif",
        "axes": [
            {
                "id": 0,
                "title": "Width",
                "min": 50,
                "max": 149.99,
                "step": 0.001,
                "css_fvs": "wdth"
            },
            {
                "id": 1,
                "title": "Slant",
                "min": -16,
                "max": 0,
                "step": 0.1,
                "css_fvs": "slnt"
            }
        ],
        "sort": 71,
        "is_active": true,
        "variable": true,
        "open_source": false,
        "license": "/*\n * This CSS file has been generated and is served by Cargo Collective Inc\n * and is authorized to be used on Cargo Collective Inc only.\n *\n * This CSS resource incorporates links to font software which is\n * the valuable copyrighted property of Dinamo Typefaces. You may not\n * attempt to copy, install, redistribute, convert, modify or reverse\n * engineer this font software. Please contact Dinamo with any\n * questions: https://abcdinamo.com/\n */",
        "variants": [
            {
                "vid": 852,
                "family_id": 244,
                "sort": 0,
                "file_name": "abc-fixes/CargoGravityVariable",
                "name": "XXXX Compressed",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "900",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wdth' 50, 'slnt' 0",
                "staff_pick": true
            },
            {
                "vid": 853,
                "family_id": 244,
                "sort": 1,
                "file_name": "abc-fixes/CargoGravityVariable",
                "name": "XXX Compressed",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "900",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wdth' 52, 'slnt' 0",
                "staff_pick": true
            },
            {
                "vid": 854,
                "family_id": 244,
                "sort": 2,
                "file_name": "abc-fixes/CargoGravityVariable",
                "name": "XX Compressed",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "900",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wdth' 55.501, 'slnt' 0",
                "staff_pick": true
            },
            {
                "vid": 855,
                "family_id": 244,
                "sort": 3,
                "file_name": "abc-fixes/CargoGravityVariable",
                "name": "X Compressed",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "900",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wdth' 59, 'slnt' 0",
                "staff_pick": true
            },
            {
                "vid": 856,
                "family_id": 244,
                "sort": 4,
                "file_name": "abc-fixes/CargoGravityVariable",
                "name": "Compressed",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "900",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wdth' 62, 'slnt' 0",
                "staff_pick": true
            },
            {
                "vid": 857,
                "family_id": 244,
                "sort": 5,
                "file_name": "abc-fixes/CargoGravityVariable",
                "name": "Extra Condensed",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "900",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wdth' 73.251, 'slnt' 0",
                "staff_pick": true
            },
            {
                "vid": 858,
                "family_id": 244,
                "sort": 6,
                "file_name": "abc-fixes/CargoGravityVariable",
                "name": "Condensed",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "900",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wdth' 85, 'slnt' 0",
                "staff_pick": true
            },
            {
                "vid": 859,
                "family_id": 244,
                "sort": 7,
                "file_name": "abc-fixes/CargoGravityVariable",
                "name": "SemiCondensed",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "900",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wdth' 92, 'slnt' 0",
                "staff_pick": true
            },
            {
                "vid": 860,
                "family_id": 244,
                "sort": 8,
                "file_name": "abc-fixes/CargoGravityVariable",
                "name": "Normal",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "900",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wdth' 100, 'slnt' 0",
                "staff_pick": true
            },
            {
                "vid": 861,
                "family_id": 244,
                "sort": 9,
                "file_name": "abc-fixes/CargoGravityVariable",
                "name": "Extended",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "900",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wdth' 115.501, 'slnt' 0",
                "staff_pick": true
            },
            {
                "vid": 862,
                "family_id": 244,
                "sort": 10,
                "file_name": "abc-fixes/CargoGravityVariable",
                "name": "Expanded",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "900",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wdth' 131.501, 'slnt' 0",
                "staff_pick": true
            },
            {
                "vid": 863,
                "family_id": 244,
                "sort": 11,
                "file_name": "abc-fixes/CargoGravityVariable",
                "name": "Wide",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "900",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wdth' 150, 'slnt' 0",
                "staff_pick": true
            },
            {
                "vid": 1104,
                "family_id": 244,
                "sort": 12,
                "file_name": "abc-fixes/CargoGravityItalicVariable",
                "name": "Normal Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "900",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 900, 'slnt' -16",
                "staff_pick": false
            }
        ]
    },
    {
        "id": 190,
        "family_name": "Georgia",
        "google_family_name": null,
        "websafe_name": "Georgia",
        "provider": "system",
        "foundry": "Matthew Carter",
        "serif": "serif",
        "axes": null,
        "sort": 72,
        "is_active": true,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 500,
                "family_id": 190,
                "sort": 0,
                "file_name": null,
                "name": null,
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": "Georgia, Georgia, serif, Georgia",
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 501,
                "family_id": 190,
                "sort": 1,
                "file_name": null,
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": "Georgia, Georgia, serif, Georgia Italic",
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 502,
                "family_id": 190,
                "sort": 2,
                "file_name": null,
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": "Georgia, Georgia, serif, Georgia Bold",
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 503,
                "family_id": 190,
                "sort": 3,
                "file_name": null,
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": "Georgia, Georgia, serif, Georgia Bold Italic",
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 120,
        "family_name": "Goudy Bookletter 1911",
        "google_family_name": "Goudy Bookletter 1911",
        "websafe_name": "GoudyBookletter1911",
        "provider": "google",
        "foundry": "Barry Schwartz",
        "serif": "serif",
        "axes": null,
        "sort": 73,
        "is_active": true,
        "variable": false,
        "open_source": true,
        "license": null,
        "variants": [
            {
                "vid": 386,
                "family_id": 120,
                "sort": 0,
                "file_name": null,
                "name": "Regular",
                "google_variant_name": "400",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 121,
        "family_name": "Sorts Mill Goudy",
        "google_family_name": "Sorts Mill Goudy",
        "websafe_name": "SortsMillGoudy",
        "provider": "google",
        "foundry": "Barry Schwartz",
        "serif": "serif",
        "axes": null,
        "sort": 74,
        "is_active": true,
        "variable": false,
        "open_source": true,
        "license": null,
        "variants": [
            {
                "vid": 387,
                "family_id": 121,
                "sort": 0,
                "file_name": null,
                "name": "Regular",
                "google_variant_name": "400",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 388,
                "family_id": 121,
                "sort": 1,
                "file_name": null,
                "name": "Regular Italic",
                "google_variant_name": "400italic",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 25,
        "family_name": "Guyot Headline",
        "google_family_name": null,
        "websafe_name": "GuyotHeadline",
        "provider": "cargo",
        "foundry": "Retype",
        "serif": "serif",
        "axes": null,
        "sort": 76,
        "is_active": true,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 81,
                "family_id": 25,
                "sort": 0,
                "file_name": "GuyotHeadline-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 82,
                "family_id": 25,
                "sort": 1,
                "file_name": "GuyotHeadline-RegularItalic",
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 83,
                "family_id": 25,
                "sort": 2,
                "file_name": "GuyotHeadline-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 84,
                "family_id": 25,
                "sort": 3,
                "file_name": "GuyotHeadline-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 194,
        "family_name": "Guyot Text",
        "google_family_name": null,
        "websafe_name": "GuyotText",
        "provider": "cargo",
        "foundry": null,
        "serif": "serif",
        "axes": null,
        "sort": 77,
        "is_active": true,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 513,
                "family_id": 194,
                "sort": 0,
                "file_name": "GuyotText-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": true
            },
            {
                "vid": 514,
                "family_id": 194,
                "sort": 1,
                "file_name": "GuyotText-Italic",
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 515,
                "family_id": 194,
                "sort": 2,
                "file_name": "GuyotText-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 516,
                "family_id": 194,
                "sort": 3,
                "file_name": "GuyotText-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 2,
        "family_name": "Alte Haas Grotesk",
        "google_family_name": null,
        "websafe_name": "AlteHaasGrotesk",
        "provider": "cargo",
        "foundry": "Yann Le Coroller",
        "serif": "sans-serif",
        "axes": null,
        "sort": 78,
        "is_active": true,
        "variable": false,
        "open_source": true,
        "license": "/*\n * Copyright (c) Yann Le Coroller\n * www.yannlecoroller.com\n */",
        "variants": [
            {
                "vid": 4,
                "family_id": 2,
                "sort": 0,
                "file_name": "AlteHaasGrotesk-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 5,
                "family_id": 2,
                "sort": 1,
                "file_name": "AlteHaasGrotesk-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 46,
        "family_name": "Neue Haas Grotesk",
        "google_family_name": null,
        "websafe_name": "NeueHaasGrotesk",
        "provider": "cargo",
        "foundry": "Font Bureau",
        "serif": "sans-serif",
        "axes": null,
        "sort": 79,
        "is_active": true,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 145,
                "family_id": 46,
                "sort": 0,
                "file_name": "NeueHaasGroteskText-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": true
            },
            {
                "vid": 147,
                "family_id": 46,
                "sort": 1,
                "file_name": "NeueHaasGroteskText-Italic",
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 149,
                "family_id": 46,
                "sort": 2,
                "file_name": "NeueHaasGroteskText-Medium",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "500",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 150,
                "family_id": 46,
                "sort": 3,
                "file_name": "NeueHaasGroteskText-MediumItalic",
                "name": "Medium Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "500",
                "css_font_fvd": "i5",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 146,
                "family_id": 46,
                "sort": 4,
                "file_name": "NeueHaasGroteskText-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 148,
                "family_id": 46,
                "sort": 5,
                "file_name": "NeueHaasGroteskText-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 29,
        "family_name": "Happy Times at the IKOB",
        "google_family_name": null,
        "websafe_name": "HappyTimesattheIKOB",
        "provider": "cargo",
        "foundry": "Lucas Le Bihan",
        "serif": "serif",
        "axes": null,
        "sort": 83,
        "is_active": true,
        "variable": false,
        "open_source": true,
        "license": "/*\n * Copyright © Lucas Le Bihan\n * https://www.velvetyne.fr/fonts/happy-times/\n */",
        "variants": [
            {
                "vid": 89,
                "family_id": 29,
                "sort": 0,
                "file_name": "HappyTimesAtTheIKOBNewGamePlusEdition-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 90,
                "family_id": 29,
                "sort": 1,
                "file_name": "HappyTimesAtTheIKOBNewGamePlusEdition-Italic",
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 88,
                "family_id": 29,
                "sort": 2,
                "file_name": "HappyTimesAtTheIKOBNewGamePlusEdition-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 186,
        "family_name": "Helvetica Neue",
        "google_family_name": null,
        "websafe_name": "HelveticaNeue",
        "provider": "system",
        "foundry": "Max Miedinger",
        "serif": "sans-serif",
        "axes": null,
        "sort": 84,
        "is_active": true,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 485,
                "family_id": 186,
                "sort": 0,
                "file_name": null,
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": "HelveticaNeue-Light, Helvetica Neue Light",
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 486,
                "family_id": 186,
                "sort": 1,
                "file_name": null,
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": "Helvetica Neue, Helvetica, sans-serif, Helvetica Neue Regular",
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 487,
                "family_id": 186,
                "sort": 2,
                "file_name": null,
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": "Helvetica Neue, Helvetica, sans-serif, Helvetica Neue Italic",
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 488,
                "family_id": 186,
                "sort": 3,
                "file_name": null,
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": "Helvetica Neue, Helvetica, sans-serif, Helvetica Neue Bold",
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 489,
                "family_id": 186,
                "sort": 4,
                "file_name": null,
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": "Helvetica Neue, Helvetica, sans-serif, Helvetica Neue Bold Italic",
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 30,
        "family_name": "Herald Gothic",
        "google_family_name": null,
        "websafe_name": "HeraldGothic",
        "provider": "cargo",
        "foundry": "Matthew Butterick",
        "serif": "sans-serif",
        "axes": null,
        "sort": 85,
        "is_active": false,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 91,
                "family_id": 30,
                "sort": 0,
                "file_name": "HeraldGothic-Light",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 92,
                "family_id": 30,
                "sort": 1,
                "file_name": "HeraldGothic-Medium",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 93,
                "family_id": 30,
                "sort": 2,
                "file_name": "HeraldGothic-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 32,
        "family_name": "Infini GF",
        "google_family_name": null,
        "websafe_name": "InfiniGF",
        "provider": "cargo",
        "foundry": "Sandrine Nugue",
        "serif": "sans-serif",
        "axes": null,
        "sort": 86,
        "is_active": true,
        "variable": false,
        "open_source": true,
        "license": "/*\n * The Infini typeface can be used freely, in private or professional contexts, under the Creative Commons CC BY-ND license.\n * \n * The Infini typeface used in this document was created by Sandrine Nugue as part of a public commission by the Centre national des arts plastiques.\n * \n * More information about the Creative Commons CC BY-ND licence http://creativecommons.org/licenses/by-nd/3.0/\n */",
        "variants": [
            {
                "vid": 98,
                "family_id": 32,
                "sort": 0,
                "file_name": "InfiniGF-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 99,
                "family_id": 32,
                "sort": 1,
                "file_name": "InfiniGF-Italic",
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 100,
                "family_id": 32,
                "sort": 2,
                "file_name": "InfiniGF-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 33,
        "family_name": "Infini GF Ligatures",
        "google_family_name": null,
        "websafe_name": "InfiniGFLigatures",
        "provider": "cargo",
        "foundry": "Sandrine Nugue",
        "serif": "sans-serif",
        "axes": null,
        "sort": 87,
        "is_active": true,
        "variable": false,
        "open_source": true,
        "license": "/*\n * The Infini typeface can be used freely, in private or professional contexts, under the Creative Commons CC BY-ND license.\n * \n * The Infini typeface used in this document was created by Sandrine Nugue as part of a public commission by the Centre national des arts plastiques.\n * \n * More information about the Creative Commons CC BY-ND licence http://creativecommons.org/licenses/by-nd/3.0/\n */",
        "variants": [
            {
                "vid": 101,
                "family_id": 33,
                "sort": 0,
                "file_name": "InfiniGF-Regular",
                "name": "",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 288,
        "family_name": "Instrument Serif",
        "google_family_name": "Instrument Serif",
        "websafe_name": "InstrumentSerif",
        "provider": "google",
        "foundry": "Rodrigo Fuenzalida, Jordan Egstad",
        "serif": "serif",
        "axes": null,
        "sort": 88,
        "is_active": true,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 1174,
                "family_id": 288,
                "sort": 0,
                "file_name": null,
                "name": "Regular",
                "google_variant_name": "400",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1175,
                "family_id": 288,
                "sort": 1,
                "file_name": null,
                "name": "Regular Italic",
                "google_variant_name": "400italic",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 34,
        "family_name": "Inter",
        "google_family_name": null,
        "websafe_name": "Inter",
        "provider": "cargo",
        "foundry": "Rasmus Andersson",
        "serif": "sans-serif",
        "axes": null,
        "sort": 89,
        "is_active": true,
        "variable": false,
        "open_source": true,
        "license": "/*\n * Copyright (c) 2016-2019 The Inter Project Authors ( https://rsms.me/ )\n */",
        "variants": [
            {
                "vid": 102,
                "family_id": 34,
                "sort": 0,
                "file_name": "Inter-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 104,
                "family_id": 34,
                "sort": 1,
                "file_name": "Inter-Italic",
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 103,
                "family_id": 34,
                "sort": 2,
                "file_name": "Inter-SemiBold",
                "name": "Semi Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "600",
                "css_font_fvd": "n6",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 105,
                "family_id": 34,
                "sort": 3,
                "file_name": "Inter-SemiBoldItalic",
                "name": "Semi Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "600",
                "css_font_fvd": "i6",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 106,
                "family_id": 34,
                "sort": 4,
                "file_name": "Inter-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 107,
                "family_id": 34,
                "sort": 5,
                "file_name": "Inter-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 109,
                "family_id": 34,
                "sort": 6,
                "file_name": "Inter-Black",
                "name": "Black",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "900",
                "css_font_fvd": "n9",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 108,
                "family_id": 34,
                "sort": 7,
                "file_name": "Inter-BlackItalic",
                "name": "Black Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "900",
                "css_font_fvd": "i9",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 35,
        "family_name": "Interstate",
        "google_family_name": null,
        "websafe_name": "Interstate",
        "provider": "cargo",
        "foundry": "Font Bureau",
        "serif": "sans-serif",
        "axes": null,
        "sort": 90,
        "is_active": true,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 110,
                "family_id": 35,
                "sort": 0,
                "file_name": "Interstate-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 111,
                "family_id": 35,
                "sort": 1,
                "file_name": "Interstate-RegularItalic",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 112,
                "family_id": 35,
                "sort": 2,
                "file_name": "Interstate-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 113,
                "family_id": 35,
                "sort": 3,
                "file_name": "Interstate-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 208,
        "family_name": "Jura",
        "google_family_name": "Jura",
        "websafe_name": "Jura",
        "provider": "google",
        "foundry": "",
        "serif": "sans-serif",
        "axes": null,
        "sort": 93,
        "is_active": false,
        "variable": false,
        "open_source": true,
        "license": null,
        "variants": [
            {
                "vid": 586,
                "family_id": 208,
                "sort": 0,
                "file_name": null,
                "name": "Light",
                "google_variant_name": "300",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 587,
                "family_id": 208,
                "sort": 1,
                "file_name": null,
                "name": "Regular",
                "google_variant_name": "400",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 588,
                "family_id": 208,
                "sort": 2,
                "file_name": null,
                "name": "Medium",
                "google_variant_name": "500",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 589,
                "family_id": 208,
                "sort": 3,
                "file_name": null,
                "name": "Semi-Bold",
                "google_variant_name": "600",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 590,
                "family_id": 208,
                "sort": 4,
                "file_name": null,
                "name": "Bold",
                "google_variant_name": "700",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 122,
        "family_name": "Linden Hill",
        "google_family_name": "Linden Hill",
        "websafe_name": "LindenHill",
        "provider": "google",
        "foundry": "Barry Schwartz",
        "serif": "serif",
        "axes": null,
        "sort": 98,
        "is_active": true,
        "variable": false,
        "open_source": true,
        "license": null,
        "variants": [
            {
                "vid": 389,
                "family_id": 122,
                "sort": 0,
                "file_name": null,
                "name": "Regular",
                "google_variant_name": "400",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 390,
                "family_id": 122,
                "sort": 1,
                "file_name": null,
                "name": "Regular Italic",
                "google_variant_name": "400italic",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 188,
        "family_name": "Lucida Grande",
        "google_family_name": null,
        "websafe_name": "LucidaGrande",
        "provider": "system",
        "foundry": "Charles Bigelow, Kris Holmes",
        "serif": "sans-serif",
        "axes": null,
        "sort": 99,
        "is_active": false,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 494,
                "family_id": 188,
                "sort": 0,
                "file_name": null,
                "name": null,
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": "'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Geneva, Verdana, sans-serif, Lucida Grande",
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 495,
                "family_id": 188,
                "sort": 1,
                "file_name": null,
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": "'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Geneva, Verdana, sans-serif, Lucida Grande Bold",
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 40,
        "family_name": "Marat",
        "google_family_name": null,
        "websafe_name": "Marat",
        "provider": "cargo",
        "foundry": "Ludwig Type",
        "serif": "serif",
        "axes": null,
        "sort": 100,
        "is_active": true,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 126,
                "family_id": 40,
                "sort": 0,
                "file_name": "Marat-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 127,
                "family_id": 40,
                "sort": 1,
                "file_name": "Marat-RegularItalic",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 128,
                "family_id": 40,
                "sort": 2,
                "file_name": "Marat-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 129,
                "family_id": 40,
                "sort": 3,
                "file_name": "Marat-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 41,
        "family_name": "Marat Sans",
        "google_family_name": null,
        "websafe_name": "MaratSans",
        "provider": "cargo",
        "foundry": "Ludwig Type",
        "serif": "sans-serif",
        "axes": null,
        "sort": 101,
        "is_active": true,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 133,
                "family_id": 41,
                "sort": 0,
                "file_name": "MaratSans-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 132,
                "family_id": 41,
                "sort": 1,
                "file_name": "MaratSans-Italic",
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 130,
                "family_id": 41,
                "sort": 2,
                "file_name": "MaratSans-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 131,
                "family_id": 41,
                "sort": 3,
                "file_name": "MaratSans-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 274,
        "family_name": "Marist Variable",
        "google_family_name": null,
        "websafe_name": "MaristVariable",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "serif",
        "axes": [
            {
                "id": 0,
                "title": "Weight",
                "min": 350,
                "max": 900,
                "step": 1,
                "css_fvs": "wght"
            }
        ],
        "sort": 102,
        "is_active": true,
        "variable": true,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 1105,
                "family_id": 274,
                "sort": 0,
                "file_name": "CargoMaristVariable",
                "name": "Book",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "350 900",
                "css_font_fvd": "n35",
                "css_font_family": null,
                "css_font_fvs": "'wght' 350",
                "staff_pick": false
            },
            {
                "vid": 1062,
                "family_id": 274,
                "sort": 1,
                "file_name": "CargoMaristVariable",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "350 900",
                "css_font_fvd": "n4",
                "css_font_family": "",
                "css_font_fvs": "'wght' 400",
                "staff_pick": true
            },
            {
                "vid": 1063,
                "family_id": 274,
                "sort": 2,
                "file_name": "CargoMaristVariable",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "350 900",
                "css_font_fvd": "n5",
                "css_font_family": "",
                "css_font_fvs": "'wght' 500",
                "staff_pick": false
            },
            {
                "vid": 1064,
                "family_id": 274,
                "sort": 3,
                "file_name": "CargoMaristVariable",
                "name": "Semibold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "350 900",
                "css_font_fvd": "n6",
                "css_font_family": "",
                "css_font_fvs": "'wght' 600",
                "staff_pick": false
            },
            {
                "vid": 1065,
                "family_id": 274,
                "sort": 4,
                "file_name": "CargoMaristVariable",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "350 900",
                "css_font_fvd": "n7",
                "css_font_family": "",
                "css_font_fvs": "'wght' 700",
                "staff_pick": false
            },
            {
                "vid": 1066,
                "family_id": 274,
                "sort": 5,
                "file_name": "CargoMaristVariable",
                "name": "Black",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "350 900",
                "css_font_fvd": "n9",
                "css_font_family": "",
                "css_font_fvs": "'wght' 900",
                "staff_pick": false
            },
            {
                "vid": 1068,
                "family_id": 274,
                "sort": 6,
                "file_name": "CargoMaristItalicVariable",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "350 900",
                "css_font_fvd": "i4",
                "css_font_family": "",
                "css_font_fvs": "'wght' 400",
                "staff_pick": false
            }
        ]
    },
    {
        "id": 105,
        "family_name": "Michroma",
        "google_family_name": "Michroma",
        "websafe_name": "Michroma",
        "provider": "google",
        "foundry": "Vernon Adams",
        "serif": "sans-serif",
        "axes": null,
        "sort": 104,
        "is_active": false,
        "variable": false,
        "open_source": true,
        "license": null,
        "variants": [
            {
                "vid": 335,
                "family_id": 105,
                "sort": 0,
                "file_name": null,
                "name": "Regular",
                "google_variant_name": "400",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 43,
        "family_name": "Miller Text",
        "google_family_name": null,
        "websafe_name": "MillerText",
        "provider": "cargo",
        "foundry": "Carter & Cone",
        "serif": "serif",
        "axes": null,
        "sort": 105,
        "is_active": true,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 136,
                "family_id": 43,
                "sort": 0,
                "file_name": "MillerText-Roman",
                "name": "Roman",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 137,
                "family_id": 43,
                "sort": 1,
                "file_name": "MillerText-Italic",
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 138,
                "family_id": 43,
                "sort": 2,
                "file_name": "MillerText-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 139,
                "family_id": 43,
                "sort": 3,
                "file_name": "MillerText-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 264,
        "family_name": "Montagu Slab Variable",
        "google_family_name": null,
        "websafe_name": "MontaguSlabVariable",
        "provider": "cargo",
        "foundry": "Florian Karsten",
        "serif": "serif",
        "axes": [
            {
                "id": 1,
                "title": "Weight",
                "min": 100,
                "max": 700,
                "step": 1,
                "css_fvs": "wght"
            },
            {
                "id": 0,
                "title": "Optical Size",
                "min": 16,
                "max": 144,
                "step": 1,
                "css_fvs": "opsz"
            }
        ],
        "sort": 107,
        "is_active": true,
        "variable": false,
        "open_source": true,
        "license": null,
        "variants": [
            {
                "vid": 998,
                "family_id": 264,
                "sort": 0,
                "file_name": "MontaguSlab",
                "name": "Thin",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 700",
                "css_font_fvd": "n1",
                "css_font_family": null,
                "css_font_fvs": "'wght' 100, 'opsz' 16",
                "staff_pick": false
            },
            {
                "vid": 999,
                "family_id": 264,
                "sort": 1,
                "file_name": "MontaguSlab",
                "name": "ExtraLight",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 700",
                "css_font_fvd": "n2",
                "css_font_family": null,
                "css_font_fvs": "'wght' 200, 'opsz' 16",
                "staff_pick": false
            },
            {
                "vid": 1000,
                "family_id": 264,
                "sort": 2,
                "file_name": "MontaguSlab",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 700",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": "'wght' 300, 'opsz' 16",
                "staff_pick": false
            },
            {
                "vid": 1001,
                "family_id": 264,
                "sort": 3,
                "file_name": "MontaguSlab",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 700",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'opsz' 16",
                "staff_pick": false
            },
            {
                "vid": 1002,
                "family_id": 264,
                "sort": 4,
                "file_name": "MontaguSlab",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 700",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": "'wght' 500, 'opsz' 16",
                "staff_pick": false
            },
            {
                "vid": 1003,
                "family_id": 264,
                "sort": 5,
                "file_name": "MontaguSlab",
                "name": "SemiBold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 700",
                "css_font_fvd": "n6",
                "css_font_family": null,
                "css_font_fvs": "'wght' 600, 'opsz' 16",
                "staff_pick": false
            },
            {
                "vid": 1004,
                "family_id": 264,
                "sort": 6,
                "file_name": "MontaguSlab",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 700",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": "'wght' 700, 'opsz' 16",
                "staff_pick": false
            }
        ]
    },
    {
        "id": 106,
        "family_name": "Montserrat",
        "google_family_name": "Montserrat",
        "websafe_name": "Montserrat",
        "provider": "google",
        "foundry": "Julieta Ulanovsky",
        "serif": "sans-serif",
        "axes": null,
        "sort": 108,
        "is_active": false,
        "variable": false,
        "open_source": true,
        "license": null,
        "variants": [
            {
                "vid": 336,
                "family_id": 106,
                "sort": 0,
                "file_name": null,
                "name": "Regular",
                "google_variant_name": "400",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 337,
                "family_id": 106,
                "sort": 1,
                "file_name": null,
                "name": "Bold",
                "google_variant_name": "700",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 245,
        "family_name": "Monument Grotesk Variable",
        "google_family_name": null,
        "websafe_name": "MonumentGroteskVariable",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "sans-serif",
        "axes": [
            {
                "id": 0,
                "title": "Weight",
                "min": 200,
                "max": 1000,
                "step": 1,
                "css_fvs": "wght"
            },
            {
                "id": 1,
                "title": "Mono",
                "min": 0,
                "max": 1,
                "step": 0.01,
                "css_fvs": "MONO"
            },
            {
                "id": 2,
                "title": "Slant",
                "min": -10,
                "max": 0,
                "step": 0.1,
                "css_fvs": "slnt"
            }
        ],
        "sort": 109,
        "is_active": true,
        "variable": true,
        "open_source": false,
        "license": "/*\n * This CSS file has been generated and is served by Cargo Collective Inc\n * and is authorized to be used on Cargo Collective Inc only.\n *\n * This CSS resource incorporates links to font software which is\n * the valuable copyrighted property of Dinamo Typefaces. You may not\n * attempt to copy, install, redistribute, convert, modify or reverse\n * engineer this font software. Please contact Dinamo with any\n * questions: https://abcdinamo.com/\n */",
        "variants": [
            {
                "vid": 879,
                "family_id": 245,
                "sort": 0,
                "file_name": "CargoMonumentGroteskPlusVariable",
                "name": "Thin",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n2",
                "css_font_family": null,
                "css_font_fvs": "'wght' 200, 'slnt' 0, 'MONO' 0",
                "staff_pick": true
            },
            {
                "vid": 880,
                "family_id": 245,
                "sort": 1,
                "file_name": "CargoMonumentGroteskPlusVariable",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": "'wght' 300, 'slnt' 0, 'MONO' 0",
                "staff_pick": true
            },
            {
                "vid": 881,
                "family_id": 245,
                "sort": 2,
                "file_name": "CargoMonumentGroteskPlusVariable",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' 0, 'MONO' 0",
                "staff_pick": true
            },
            {
                "vid": 882,
                "family_id": 245,
                "sort": 3,
                "file_name": "CargoMonumentGroteskPlusVariable",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": "'wght' 500, 'slnt' 0, 'MONO' 0",
                "staff_pick": true
            },
            {
                "vid": 883,
                "family_id": 245,
                "sort": 4,
                "file_name": "CargoMonumentGroteskPlusVariable",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": "'wght' 700, 'slnt' 0, 'MONO' 0",
                "staff_pick": true
            },
            {
                "vid": 884,
                "family_id": 245,
                "sort": 5,
                "file_name": "CargoMonumentGroteskPlusVariable",
                "name": "Heavy",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n8",
                "css_font_family": null,
                "css_font_fvs": "'wght' 800, 'slnt' 0, 'MONO' 0",
                "staff_pick": true
            },
            {
                "vid": 885,
                "family_id": 245,
                "sort": 6,
                "file_name": "CargoMonumentGroteskPlusVariable",
                "name": "Black",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n9",
                "css_font_family": null,
                "css_font_fvs": "'wght' 900, 'slnt' 0, 'MONO' 0",
                "staff_pick": true
            },
            {
                "vid": 886,
                "family_id": 245,
                "sort": 7,
                "file_name": "CargoMonumentGroteskPlusVariable",
                "name": "Ultra",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 1000",
                "css_font_fvd": "n10",
                "css_font_family": null,
                "css_font_fvs": "'wght' 1000, 'slnt' 0, 'MONO' 0",
                "staff_pick": true
            },
            {
                "vid": 918,
                "family_id": 245,
                "sort": 8,
                "file_name": "CargoMonumentGroteskItalicPlusVariable",
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "200 1000",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' -10, 'MONO' 0",
                "staff_pick": true
            }
        ]
    },
    {
        "id": 246,
        "family_name": "Monument Grotesk Semi-Mono Variable",
        "google_family_name": null,
        "websafe_name": "MonumentGroteskSemiMonoVariable",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "monospace",
        "axes": [
            {
                "id": 0,
                "title": "Weight",
                "min": 200,
                "max": 900,
                "step": 1,
                "css_fvs": "wght"
            },
            {
                "id": 1,
                "title": "Mono",
                "min": 0,
                "max": 1,
                "step": 0.01,
                "css_fvs": "MONO"
            },
            {
                "id": 2,
                "title": "Slant",
                "min": -10,
                "max": 0,
                "step": 0.1,
                "css_fvs": "slnt"
            }
        ],
        "sort": 110,
        "is_active": true,
        "variable": true,
        "open_source": false,
        "license": "/*\n * This CSS file has been generated and is served by Cargo Collective Inc\n * and is authorized to be used on Cargo Collective Inc only.\n *\n * This CSS resource incorporates links to font software which is\n * the valuable copyrighted property of Dinamo Typefaces. You may not\n * attempt to copy, install, redistribute, convert, modify or reverse\n * engineer this font software. Please contact Dinamo with any\n * questions: https://abcdinamo.com/\n */",
        "variants": [
            {
                "vid": 887,
                "family_id": 246,
                "sort": 0,
                "file_name": "CargoMonumentGroteskPlusVariable",
                "name": "Thin",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 900",
                "css_font_fvd": "n2",
                "css_font_family": null,
                "css_font_fvs": "'wght' 200, 'slnt' 0, 'MONO' 0.5",
                "staff_pick": false
            },
            {
                "vid": 888,
                "family_id": 246,
                "sort": 1,
                "file_name": "CargoMonumentGroteskPlusVariable",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 900",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": "'wght' 300, 'slnt' 0, 'MONO' 0.5",
                "staff_pick": false
            },
            {
                "vid": 889,
                "family_id": 246,
                "sort": 2,
                "file_name": "CargoMonumentGroteskPlusVariable",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 900",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' 0, 'MONO' 0.5",
                "staff_pick": false
            },
            {
                "vid": 890,
                "family_id": 246,
                "sort": 3,
                "file_name": "CargoMonumentGroteskPlusVariable",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 900",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": "'wght' 500, 'slnt' 0, 'MONO' 0.5",
                "staff_pick": false
            },
            {
                "vid": 891,
                "family_id": 246,
                "sort": 4,
                "file_name": "CargoMonumentGroteskPlusVariable",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 900",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": "'wght' 700, 'slnt' 0, 'MONO' 0.5",
                "staff_pick": false
            },
            {
                "vid": 892,
                "family_id": 246,
                "sort": 5,
                "file_name": "CargoMonumentGroteskPlusVariable",
                "name": "Heavy",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 900",
                "css_font_fvd": "n8",
                "css_font_family": null,
                "css_font_fvs": "'wght' 800, 'slnt' 0, 'MONO' 0.5",
                "staff_pick": false
            },
            {
                "vid": 893,
                "family_id": 246,
                "sort": 6,
                "file_name": "CargoMonumentGroteskPlusVariable",
                "name": "Black",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 900",
                "css_font_fvd": "n9",
                "css_font_family": null,
                "css_font_fvs": "'wght' 900, 'slnt' 0, 'MONO' 0.5",
                "staff_pick": false
            },
            {
                "vid": 914,
                "family_id": 246,
                "sort": 8,
                "file_name": "CargoMonumentGroteskItalicPlusVariable",
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "200 900",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' -10, 'MONO' 0.5",
                "staff_pick": false
            }
        ]
    },
    {
        "id": 247,
        "family_name": "Monument Grotesk Mono Variable",
        "google_family_name": null,
        "websafe_name": "MonumentGroteskMonoVariable",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "monospace",
        "axes": [
            {
                "id": 0,
                "title": "Weight",
                "min": 200,
                "max": 900,
                "step": 1,
                "css_fvs": "wght"
            },
            {
                "id": 1,
                "title": "Mono",
                "min": 0,
                "max": 1,
                "step": 0.01,
                "css_fvs": "MONO"
            },
            {
                "id": 2,
                "title": "Slant",
                "min": -10,
                "max": 0,
                "step": 0.1,
                "css_fvs": "slnt"
            }
        ],
        "sort": 111,
        "is_active": true,
        "variable": true,
        "open_source": false,
        "license": "/*\n * This CSS file has been generated and is served by Cargo Collective Inc\n * and is authorized to be used on Cargo Collective Inc only.\n *\n * This CSS resource incorporates links to font software which is\n * the valuable copyrighted property of Dinamo Typefaces. You may not\n * attempt to copy, install, redistribute, convert, modify or reverse\n * engineer this font software. Please contact Dinamo with any\n * questions: https://abcdinamo.com/\n */",
        "variants": [
            {
                "vid": 895,
                "family_id": 247,
                "sort": 0,
                "file_name": "CargoMonumentGroteskPlusVariable",
                "name": "Thin",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 900",
                "css_font_fvd": "n2",
                "css_font_family": null,
                "css_font_fvs": "'wght' 200, 'slnt' 0, 'MONO' 1",
                "staff_pick": true
            },
            {
                "vid": 896,
                "family_id": 247,
                "sort": 1,
                "file_name": "CargoMonumentGroteskPlusVariable",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 900",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": "'wght' 300, 'slnt' 0, 'MONO' 1",
                "staff_pick": true
            },
            {
                "vid": 897,
                "family_id": 247,
                "sort": 2,
                "file_name": "CargoMonumentGroteskPlusVariable",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 900",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' 0, 'MONO' 1",
                "staff_pick": true
            },
            {
                "vid": 898,
                "family_id": 247,
                "sort": 3,
                "file_name": "CargoMonumentGroteskPlusVariable",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 900",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": "'wght' 500, 'slnt' 0, 'MONO' 1",
                "staff_pick": true
            },
            {
                "vid": 899,
                "family_id": 247,
                "sort": 4,
                "file_name": "CargoMonumentGroteskPlusVariable",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 900",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": "'wght' 700, 'slnt' 0, 'MONO' 1",
                "staff_pick": true
            },
            {
                "vid": 900,
                "family_id": 247,
                "sort": 5,
                "file_name": "CargoMonumentGroteskPlusVariable",
                "name": "Heavy",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 900",
                "css_font_fvd": "n8",
                "css_font_family": null,
                "css_font_fvs": "'wght' 800, 'slnt' 0, 'MONO' 1",
                "staff_pick": true
            },
            {
                "vid": 901,
                "family_id": 247,
                "sort": 6,
                "file_name": "CargoMonumentGroteskPlusVariable",
                "name": "Black",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200 900",
                "css_font_fvd": "n9",
                "css_font_family": null,
                "css_font_fvs": "'wght' 900, 'slnt' 0, 'MONO' 1",
                "staff_pick": true
            },
            {
                "vid": 917,
                "family_id": 247,
                "sort": 8,
                "file_name": "CargoMonumentGroteskItalicPlusVariable",
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "200 900",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' -10, 'MONO' 1",
                "staff_pick": true
            }
        ]
    },
    {
        "id": 232,
        "family_name": "Monument Grotesk",
        "google_family_name": null,
        "websafe_name": "MonumentGrotesk",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "sans-serif",
        "axes": null,
        "sort": 112,
        "is_active": false,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 749,
                "family_id": 232,
                "sort": 0,
                "file_name": "CargoMonumentGrotesk-Thin",
                "name": "Thin",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200",
                "css_font_fvd": "n2",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 750,
                "family_id": 232,
                "sort": 1,
                "file_name": "CargoMonumentGrotesk-ThinItalic",
                "name": "Thin Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "200",
                "css_font_fvd": "i2",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 751,
                "family_id": 232,
                "sort": 2,
                "file_name": "CargoMonumentGrotesk-Light",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 752,
                "family_id": 232,
                "sort": 3,
                "file_name": "CargoMonumentGrotesk-LightItalic",
                "name": "Light Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "300",
                "css_font_fvd": "i3",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 735,
                "family_id": 232,
                "sort": 4,
                "file_name": "CargoMonumentGrotesk-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "400",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": true
            },
            {
                "vid": 736,
                "family_id": 232,
                "sort": 5,
                "file_name": "CargoMonumentGrotesk-RegularItalic",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "400",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 737,
                "family_id": 232,
                "sort": 6,
                "file_name": "CargoMonumentGrotesk-Medium",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "500",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 738,
                "family_id": 232,
                "sort": 7,
                "file_name": "CargoMonumentGrotesk-MediumItalic",
                "name": "Medium Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "500",
                "css_font_fvd": "i5",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 753,
                "family_id": 232,
                "sort": 8,
                "file_name": "CargoMonumentGrotesk-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "700",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 754,
                "family_id": 232,
                "sort": 9,
                "file_name": "CargoMonumentGrotesk-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "700",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 755,
                "family_id": 232,
                "sort": 10,
                "file_name": "CargoMonumentGrotesk-Heavy",
                "name": "Heavy",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "800",
                "css_font_fvd": "n8",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 756,
                "family_id": 232,
                "sort": 11,
                "file_name": "CargoMonumentGrotesk-HeavyItalic",
                "name": "Heavy Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "800",
                "css_font_fvd": "i8",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 743,
                "family_id": 232,
                "sort": 12,
                "file_name": "CargoMonumentGrotesk-Black",
                "name": "Black",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "900",
                "css_font_fvd": "n9",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 744,
                "family_id": 232,
                "sort": 13,
                "file_name": "CargoMonumentGrotesk-BlackItalic",
                "name": "Black Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "900",
                "css_font_fvd": "i9",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 745,
                "family_id": 232,
                "sort": 14,
                "file_name": "CargoMonumentGrotesk-Ultra",
                "name": "Ultra",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "1000",
                "css_font_fvd": "n10",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 746,
                "family_id": 232,
                "sort": 15,
                "file_name": "CargoMonumentGrotesk-UltraItalic",
                "name": "Ultra Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "1000",
                "css_font_fvd": "i10",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 228,
        "family_name": "Monument Grotesk Mono",
        "google_family_name": null,
        "websafe_name": "MonumentGroteskMono",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "monospace",
        "axes": null,
        "sort": 113,
        "is_active": false,
        "variable": false,
        "open_source": false,
        "license": "/*\n * This CSS file has been generated and is served by Cargo Collective Inc\n * and is authorized to be used on Cargo Collective Inc only.\n *\n * This CSS resource incorporates links to font software which is\n * the valuable copyrighted property of Dinamo Typefaces. You may not\n * attempt to copy, install, redistribute, convert, modify or reverse\n * engineer this font software. Please contact Dinamo with any\n * questions: https://abcdinamo.com/\n */",
        "variants": [
            {
                "vid": 773,
                "family_id": 228,
                "sort": 0,
                "file_name": "CargoMonumentGroteskMono-Thin",
                "name": "Thin",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200",
                "css_font_fvd": "n2",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 774,
                "family_id": 228,
                "sort": 1,
                "file_name": "CargoMonumentGroteskMono-ThinItalic",
                "name": "Thin Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "200",
                "css_font_fvd": "i2",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 775,
                "family_id": 228,
                "sort": 2,
                "file_name": "CargoMonumentGroteskMono-Light",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 776,
                "family_id": 228,
                "sort": 3,
                "file_name": "CargoMonumentGroteskMono-LightItalic",
                "name": "Light Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "300",
                "css_font_fvd": "i3",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 726,
                "family_id": 228,
                "sort": 4,
                "file_name": "CargoMonumentGroteskMono-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "400",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": true
            },
            {
                "vid": 777,
                "family_id": 228,
                "sort": 5,
                "file_name": "CargoMonumentGroteskMono-RegularItalic",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "400",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 778,
                "family_id": 228,
                "sort": 6,
                "file_name": "CargoMonumentGroteskMono-Medium",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "500",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 779,
                "family_id": 228,
                "sort": 7,
                "file_name": "CargoMonumentGroteskMono-MediumItalic",
                "name": "Medium italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "500",
                "css_font_fvd": "i5",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 780,
                "family_id": 228,
                "sort": 8,
                "file_name": "CargoMonumentGroteskMono-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "700",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 781,
                "family_id": 228,
                "sort": 9,
                "file_name": "CargoMonumentGroteskMono-BoldItalic",
                "name": "Bold italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "700",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 782,
                "family_id": 228,
                "sort": 10,
                "file_name": "CargoMonumentGroteskMono-Heavy",
                "name": "Heavy",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "800",
                "css_font_fvd": "n8",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 783,
                "family_id": 228,
                "sort": 11,
                "file_name": "CargoMonumentGroteskMono-HeavyItalic",
                "name": "Heavy Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "800",
                "css_font_fvd": "i8",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 784,
                "family_id": 228,
                "sort": 12,
                "file_name": "CargoMonumentGroteskMono-Black",
                "name": "Black",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "900",
                "css_font_fvd": "n9",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 785,
                "family_id": 228,
                "sort": 13,
                "file_name": "CargoMonumentGroteskMono-BlackItalic",
                "name": "Black Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "900",
                "css_font_fvd": "i9",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 229,
        "family_name": "Monument Grotesk Semi-Mono",
        "google_family_name": null,
        "websafe_name": "MonumentGroteskSemiMono",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "monospace",
        "axes": null,
        "sort": 114,
        "is_active": false,
        "variable": false,
        "open_source": false,
        "license": "/*\n * This CSS file has been generated and is served by Cargo Collective Inc\n * and is authorized to be used on Cargo Collective Inc only.\n *\n * This CSS resource incorporates links to font software which is\n * the valuable copyrighted property of Dinamo Typefaces. You may not\n * attempt to copy, install, redistribute, convert, modify or reverse\n * engineer this font software. Please contact Dinamo with any\n * questions: https://abcdinamo.com/\n */",
        "variants": [
            {
                "vid": 786,
                "family_id": 229,
                "sort": 0,
                "file_name": "CargoMonumentGroteskSemi-Mono-Thin",
                "name": "Thin",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200",
                "css_font_fvd": "n2",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 787,
                "family_id": 229,
                "sort": 1,
                "file_name": "CargoMonumentGroteskSemi-Mono-ThinItalic",
                "name": "Thin Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "200",
                "css_font_fvd": "i2",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 788,
                "family_id": 229,
                "sort": 2,
                "file_name": "CargoMonumentGroteskSemi-Mono-Light",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 789,
                "family_id": 229,
                "sort": 3,
                "file_name": "CargoMonumentGroteskSemi-Mono-LightItalic",
                "name": "Light Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "300",
                "css_font_fvd": "i3",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 727,
                "family_id": 229,
                "sort": 4,
                "file_name": "CargoMonumentGroteskSemi-Mono-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "400",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 790,
                "family_id": 229,
                "sort": 5,
                "file_name": "CargoMonumentGroteskSemi-Mono-RegularItalic",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "400",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 791,
                "family_id": 229,
                "sort": 6,
                "file_name": "CargoMonumentGroteskSemi-Mono-Medium",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "500",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 792,
                "family_id": 229,
                "sort": 7,
                "file_name": "CargoMonumentGroteskSemi-Mono-MediumItalic",
                "name": "Medium Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "500",
                "css_font_fvd": "i5",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 793,
                "family_id": 229,
                "sort": 8,
                "file_name": "CargoMonumentGroteskSemi-Mono-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "700",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 794,
                "family_id": 229,
                "sort": 9,
                "file_name": "CargoMonumentGroteskSemi-Mono-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "700",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 795,
                "family_id": 229,
                "sort": 10,
                "file_name": "CargoMonumentGroteskSemi-Mono-Heavy",
                "name": "Heavy",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "800",
                "css_font_fvd": "n8",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 796,
                "family_id": 229,
                "sort": 11,
                "file_name": "CargoMonumentGroteskSemi-Mono-HeavyItalic",
                "name": "Heavy Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "800",
                "css_font_fvd": "i8",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 797,
                "family_id": 229,
                "sort": 12,
                "file_name": "CargoMonumentGroteskSemi-Mono-Black",
                "name": "Black",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "900",
                "css_font_fvd": "n9",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 798,
                "family_id": 229,
                "sort": 13,
                "file_name": "CargoMonumentGroteskSemi-Mono-BlackItalic",
                "name": "Black Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "900",
                "css_font_fvd": "i9",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 287,
        "family_name": "MVB Solitaire",
        "google_family_name": null,
        "websafe_name": "MVBSolitaire",
        "provider": "cargo",
        "foundry": "",
        "serif": "sans-serif",
        "axes": null,
        "sort": 115,
        "is_active": true,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 1169,
                "family_id": 287,
                "sort": 0,
                "file_name": "MVBSolitaire-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "400",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1170,
                "family_id": 287,
                "sort": 1,
                "file_name": "MVBSolitaire-Italic",
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "400",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1171,
                "family_id": 287,
                "sort": 2,
                "file_name": "MVBSolitaire-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "700",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1172,
                "family_id": 287,
                "sort": 3,
                "file_name": "MVBSolitaire-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "700",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 47,
        "family_name": "New Hero",
        "google_family_name": null,
        "websafe_name": "NewHero",
        "provider": "cargo",
        "foundry": "Miles Newlyn",
        "serif": "sans-serif",
        "axes": null,
        "sort": 117,
        "is_active": false,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 151,
                "family_id": 47,
                "sort": 0,
                "file_name": "NewHero-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 152,
                "family_id": 47,
                "sort": 1,
                "file_name": "NewHero-Italic",
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 153,
                "family_id": 47,
                "sort": 2,
                "file_name": "NewHero-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 154,
                "family_id": 47,
                "sort": 3,
                "file_name": "NewHero-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 155,
                "family_id": 47,
                "sort": 4,
                "file_name": "NewHero-Super",
                "name": "Super",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "900",
                "css_font_fvd": "n9",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 156,
                "family_id": 47,
                "sort": 5,
                "file_name": "NewHero-SuperItalic",
                "name": "Super Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "900",
                "css_font_fvd": "i9",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 238,
        "family_name": "Newsreader",
        "google_family_name": "Newsreader",
        "websafe_name": "Newsreader",
        "provider": "google",
        "foundry": "Production Type",
        "serif": "serif",
        "axes": null,
        "sort": 118,
        "is_active": true,
        "variable": false,
        "open_source": true,
        "license": null,
        "variants": [
            {
                "vid": 809,
                "family_id": 238,
                "sort": 0,
                "file_name": null,
                "name": "Extra Light",
                "google_variant_name": "200",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 810,
                "family_id": 238,
                "sort": 1,
                "file_name": null,
                "name": "Extra Light Italic",
                "google_variant_name": "200italic",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 811,
                "family_id": 238,
                "sort": 2,
                "file_name": null,
                "name": "Light",
                "google_variant_name": "300",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 812,
                "family_id": 238,
                "sort": 3,
                "file_name": null,
                "name": "Light Italic",
                "google_variant_name": "300italic",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 813,
                "family_id": 238,
                "sort": 4,
                "file_name": null,
                "name": "Regular",
                "google_variant_name": "400",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 814,
                "family_id": 238,
                "sort": 5,
                "file_name": null,
                "name": "Regular Italic",
                "google_variant_name": "400italic",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 815,
                "family_id": 238,
                "sort": 6,
                "file_name": null,
                "name": "Medium",
                "google_variant_name": "500",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 816,
                "family_id": 238,
                "sort": 7,
                "file_name": null,
                "name": "Medium Italic",
                "google_variant_name": "500italic",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 817,
                "family_id": 238,
                "sort": 8,
                "file_name": null,
                "name": "Semi-bold",
                "google_variant_name": "600",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 818,
                "family_id": 238,
                "sort": 9,
                "file_name": null,
                "name": "Semi-bold Italic",
                "google_variant_name": "600italic",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 819,
                "family_id": 238,
                "sort": 10,
                "file_name": null,
                "name": "Bold",
                "google_variant_name": "700",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 820,
                "family_id": 238,
                "sort": 11,
                "file_name": null,
                "name": "Bold Italic",
                "google_variant_name": "700italic",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 821,
                "family_id": 238,
                "sort": 12,
                "file_name": null,
                "name": "Extra Bold",
                "google_variant_name": "800",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 822,
                "family_id": 238,
                "sort": 13,
                "file_name": null,
                "name": "Extra Bold Italic",
                "google_variant_name": "800italic",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 48,
        "family_name": "Nitti",
        "google_family_name": null,
        "websafe_name": "Nitti",
        "provider": "cargo",
        "foundry": "Bold Monday",
        "serif": "monospace",
        "axes": null,
        "sort": 119,
        "is_active": true,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 159,
                "family_id": 48,
                "sort": 0,
                "file_name": "Nitti-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 160,
                "family_id": 48,
                "sort": 1,
                "file_name": "Nitti-Italic",
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 157,
                "family_id": 48,
                "sort": 2,
                "file_name": "Nitti-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 158,
                "family_id": 48,
                "sort": 3,
                "file_name": "Nitti-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 49,
        "family_name": "Nitti Grotesk",
        "google_family_name": null,
        "websafe_name": "NittiGrotesk",
        "provider": "cargo",
        "foundry": "Bold Monday",
        "serif": "sans-serif",
        "axes": null,
        "sort": 120,
        "is_active": true,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 165,
                "family_id": 49,
                "sort": 0,
                "file_name": "NittiGrotesk-Light",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200",
                "css_font_fvd": "n2",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 166,
                "family_id": 49,
                "sort": 1,
                "file_name": "NittiGrotesk-LightItalic",
                "name": "Light Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "200",
                "css_font_fvd": "i2",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 164,
                "family_id": 49,
                "sort": 2,
                "file_name": "NittiGrotesk-Normal",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 163,
                "family_id": 49,
                "sort": 3,
                "file_name": "NittiGrotesk-Italic",
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 161,
                "family_id": 49,
                "sort": 4,
                "file_name": "NittiGrotesk-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 162,
                "family_id": 49,
                "sort": 5,
                "file_name": "NittiGrotesk-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 52,
        "family_name": "Pilowlava",
        "google_family_name": null,
        "websafe_name": "Pilowlava",
        "provider": "cargo",
        "foundry": "Anton Moglia, Jérémy Landes",
        "serif": "sans-serif",
        "axes": null,
        "sort": 127,
        "is_active": false,
        "variable": false,
        "open_source": true,
        "license": "/*\n * Copyright (c) 2019, Anton Moglia <anton@moglia.fr> & Jérémy Landes <jeremy@studiotriple.com>\n */",
        "variants": [
            {
                "vid": 170,
                "family_id": 52,
                "sort": 0,
                "file_name": "Pilowlava",
                "name": "",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 124,
        "family_name": "Pinyon Script",
        "google_family_name": "Pinyon Script",
        "websafe_name": "PinyonScript",
        "provider": "google",
        "foundry": "Nicole Fally",
        "serif": "serif",
        "axes": null,
        "sort": 128,
        "is_active": true,
        "variable": false,
        "open_source": true,
        "license": null,
        "variants": [
            {
                "vid": 397,
                "family_id": 124,
                "sort": 0,
                "file_name": null,
                "name": "",
                "google_variant_name": "400",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 53,
        "family_name": "Planet",
        "google_family_name": null,
        "websafe_name": "Planet",
        "provider": "cargo",
        "foundry": "TypeManufactur",
        "serif": "sans-serif",
        "axes": null,
        "sort": 129,
        "is_active": false,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 171,
                "family_id": 53,
                "sort": 0,
                "file_name": "Planet-Book",
                "name": "Book",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 172,
                "family_id": 53,
                "sort": 1,
                "file_name": "Planet-BookItalic",
                "name": "Book Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 173,
                "family_id": 53,
                "sort": 2,
                "file_name": "Planet-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 174,
                "family_id": 53,
                "sort": 3,
                "file_name": "Planet-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 262,
        "family_name": "Adobe Poetica",
        "google_family_name": null,
        "websafe_name": "AdobePoetica",
        "provider": "cargo",
        "foundry": null,
        "serif": "serif",
        "axes": null,
        "sort": 130,
        "is_active": true,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 979,
                "family_id": 262,
                "sort": 0,
                "file_name": "PoeticaStd-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 54,
        "family_name": "Plex Mono",
        "google_family_name": null,
        "websafe_name": "PlexMono",
        "provider": "cargo",
        "foundry": "IBM",
        "serif": "monospace",
        "axes": null,
        "sort": 131,
        "is_active": false,
        "variable": false,
        "open_source": true,
        "license": "/*\n * Copyright © 2017 IBM Corp. with Reserved Font Name \"Plex\"\n * \n * This Font Software is licensed under the SIL Open Font License, Version 1.1. This license is available with a FAQ at: http://scripts.sil.org/OFL\n */\n",
        "variants": [
            {
                "vid": 175,
                "family_id": 54,
                "sort": 0,
                "file_name": "PlexMono-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": true
            },
            {
                "vid": 176,
                "family_id": 54,
                "sort": 1,
                "file_name": "PlexMono-Italic",
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 177,
                "family_id": 54,
                "sort": 2,
                "file_name": "PlexMono-SemiBold",
                "name": "Semi Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 178,
                "family_id": 54,
                "sort": 3,
                "file_name": "PlexMono-SemiBoldItalic",
                "name": "Semi Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 55,
        "family_name": "Plex Sans",
        "google_family_name": null,
        "websafe_name": "PlexSans",
        "provider": "cargo",
        "foundry": "IBM",
        "serif": "sans-serif",
        "axes": null,
        "sort": 132,
        "is_active": false,
        "variable": false,
        "open_source": true,
        "license": "/*\n * Copyright © 2017 IBM Corp. with Reserved Font Name \"Plex\"\n * \n * This Font Software is licensed under the SIL Open Font License, Version 1.1. This license is available with a FAQ at: http://scripts.sil.org/OFL\n */\n",
        "variants": [
            {
                "vid": 179,
                "family_id": 55,
                "sort": 0,
                "file_name": "PlexSans-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": true
            },
            {
                "vid": 180,
                "family_id": 55,
                "sort": 1,
                "file_name": "PlexSans-Italic",
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 181,
                "family_id": 55,
                "sort": 2,
                "file_name": "PlexSans-SemiBold",
                "name": "Semi Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 182,
                "family_id": 55,
                "sort": 3,
                "file_name": "PlexSans-SemiBoldItalic",
                "name": "Semi Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 192,
        "family_name": "IBM Plex Mono",
        "google_family_name": "IBM Plex Mono",
        "websafe_name": "IBMPlexMono",
        "provider": "google",
        "foundry": "Mike Abbink, Bold Monday",
        "serif": "monospace",
        "axes": null,
        "sort": 133,
        "is_active": true,
        "variable": false,
        "open_source": true,
        "license": null,
        "variants": [
            {
                "vid": 523,
                "family_id": 192,
                "sort": 0,
                "file_name": null,
                "name": "Light",
                "google_variant_name": "300",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 524,
                "family_id": 192,
                "sort": 1,
                "file_name": null,
                "name": "Light Italic",
                "google_variant_name": "300italic",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 505,
                "family_id": 192,
                "sort": 2,
                "file_name": null,
                "name": "Regular",
                "google_variant_name": "400",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 506,
                "family_id": 192,
                "sort": 3,
                "file_name": null,
                "name": "Italic",
                "google_variant_name": "400italic",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 507,
                "family_id": 192,
                "sort": 4,
                "file_name": null,
                "name": "SemiBold",
                "google_variant_name": "600",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 508,
                "family_id": 192,
                "sort": 5,
                "file_name": null,
                "name": "SemiBold Italic",
                "google_variant_name": "600italic",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 525,
                "family_id": 192,
                "sort": 6,
                "file_name": null,
                "name": "Bold",
                "google_variant_name": "700",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 526,
                "family_id": 192,
                "sort": 7,
                "file_name": null,
                "name": "Bold Italic",
                "google_variant_name": "700italic",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 193,
        "family_name": "IBM Plex Sans",
        "google_family_name": "IBM Plex Sans",
        "websafe_name": "IBMPlexSans",
        "provider": "google",
        "foundry": "Mike Abbink, Bold Monday",
        "serif": "sans-serif",
        "axes": null,
        "sort": 134,
        "is_active": true,
        "variable": false,
        "open_source": true,
        "license": null,
        "variants": [
            {
                "vid": 527,
                "family_id": 193,
                "sort": 0,
                "file_name": null,
                "name": "Light",
                "google_variant_name": "300",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 528,
                "family_id": 193,
                "sort": 1,
                "file_name": null,
                "name": "Light Italic",
                "google_variant_name": "300italic",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 509,
                "family_id": 193,
                "sort": 2,
                "file_name": null,
                "name": "Regular",
                "google_variant_name": "400",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 510,
                "family_id": 193,
                "sort": 3,
                "file_name": null,
                "name": "Italic",
                "google_variant_name": "400italic",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 511,
                "family_id": 193,
                "sort": 4,
                "file_name": null,
                "name": "SemiBold",
                "google_variant_name": "600",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 512,
                "family_id": 193,
                "sort": 5,
                "file_name": null,
                "name": "SemiBold Italic",
                "google_variant_name": "600italic",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 529,
                "family_id": 193,
                "sort": 6,
                "file_name": null,
                "name": "Bold",
                "google_variant_name": "700",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 530,
                "family_id": 193,
                "sort": 7,
                "file_name": null,
                "name": "Bold Italic",
                "google_variant_name": "700italic",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 109,
        "family_name": "Quicksand",
        "google_family_name": "Quicksand",
        "websafe_name": "Quicksand",
        "provider": "google",
        "foundry": "Andrew Paglinawan",
        "serif": "sans-serif",
        "axes": null,
        "sort": 135,
        "is_active": false,
        "variable": false,
        "open_source": true,
        "license": null,
        "variants": [
            {
                "vid": 344,
                "family_id": 109,
                "sort": 0,
                "file_name": null,
                "name": "Regular",
                "google_variant_name": "400",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 345,
                "family_id": 109,
                "sort": 1,
                "file_name": null,
                "name": "Bold",
                "google_variant_name": "700",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 279,
        "family_name": "Repro Variable",
        "google_family_name": null,
        "websafe_name": "ReproVariable",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "sans-serif",
        "axes": [
            {
                "id": 0,
                "title": "Weight",
                "min": 100,
                "max": 1000,
                "step": 1,
                "css_fvs": "wght"
            },
            {
                "id": 1,
                "title": "Slant",
                "min": -14,
                "max": 0,
                "step": 0.1,
                "css_fvs": "slnt"
            }
        ],
        "sort": 137,
        "is_active": true,
        "variable": true,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 1106,
                "family_id": 279,
                "sort": 0,
                "file_name": "CargoReproVariable",
                "name": "Hairline",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 1000",
                "css_font_fvd": "n1",
                "css_font_family": null,
                "css_font_fvs": "'wght' 100, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1107,
                "family_id": 279,
                "sort": 1,
                "file_name": "CargoReproVariable",
                "name": "Thin",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 1000",
                "css_font_fvd": "n2",
                "css_font_family": null,
                "css_font_fvs": "'wght' 200, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1108,
                "family_id": 279,
                "sort": 2,
                "file_name": "CargoReproVariable",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 1000",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": "'wght' 300, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1109,
                "family_id": 279,
                "sort": 3,
                "file_name": "CargoReproVariable",
                "name": "Screen",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 1000",
                "css_font_fvd": "n35",
                "css_font_family": null,
                "css_font_fvs": "'wght' 350, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1110,
                "family_id": 279,
                "sort": 4,
                "file_name": "CargoReproVariable",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 1000",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' 0",
                "staff_pick": true
            },
            {
                "vid": 1111,
                "family_id": 279,
                "sort": 5,
                "file_name": "CargoReproVariable",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 1000",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": "'wght' 500, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1112,
                "family_id": 279,
                "sort": 6,
                "file_name": "CargoReproVariable",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 1000",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": "'wght' 700, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1113,
                "family_id": 279,
                "sort": 7,
                "file_name": "CargoReproVariable",
                "name": "Black",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 1000",
                "css_font_fvd": "n9",
                "css_font_family": null,
                "css_font_fvs": "'wght' 900, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1114,
                "family_id": 279,
                "sort": 8,
                "file_name": "CargoReproVariable",
                "name": "Ultra",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 1000",
                "css_font_fvd": "n10",
                "css_font_family": null,
                "css_font_fvs": "'wght' 1000, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1115,
                "family_id": 279,
                "sort": 9,
                "file_name": "CargoReproItalicVariable",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "100 1000",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' -14",
                "staff_pick": false
            }
        ]
    },
    {
        "id": 110,
        "family_name": "Roboto",
        "google_family_name": "Roboto",
        "websafe_name": "Roboto",
        "provider": "google",
        "foundry": "Christian Robertson",
        "serif": "sans-serif",
        "axes": null,
        "sort": 138,
        "is_active": false,
        "variable": false,
        "open_source": true,
        "license": null,
        "variants": [
            {
                "vid": 346,
                "family_id": 110,
                "sort": 0,
                "file_name": null,
                "name": "Regular",
                "google_variant_name": "400",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 347,
                "family_id": 110,
                "sort": 1,
                "file_name": null,
                "name": "Regular Italic",
                "google_variant_name": "400italic",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 348,
                "family_id": 110,
                "sort": 2,
                "file_name": null,
                "name": "Bold",
                "google_variant_name": "700",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 349,
                "family_id": 110,
                "sort": 3,
                "file_name": null,
                "name": "Bold Italic",
                "google_variant_name": "700italic",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 269,
        "family_name": "ROM Variable",
        "google_family_name": null,
        "websafe_name": "ROMVariable",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "sans-serif",
        "axes": [
            {
                "id": 0,
                "title": "Weight",
                "min": 300,
                "max": 900,
                "step": 1,
                "css_fvs": "wght"
            },
            {
                "id": 1,
                "title": "Slant",
                "min": -16,
                "max": 0,
                "step": 0.1,
                "css_fvs": "slnt"
            }
        ],
        "sort": 139,
        "is_active": true,
        "variable": true,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 1022,
                "family_id": 269,
                "sort": 0,
                "file_name": "CargoROMVariable",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300 900",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": "'wght' 300, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1023,
                "family_id": 269,
                "sort": 1,
                "file_name": "CargoROMVariable",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300 900",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' 0",
                "staff_pick": true
            },
            {
                "vid": 1024,
                "family_id": 269,
                "sort": 2,
                "file_name": "CargoROMVariable",
                "name": "Book",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300 900",
                "css_font_fvd": "n45",
                "css_font_family": null,
                "css_font_fvs": "'wght' 450, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1025,
                "family_id": 269,
                "sort": 3,
                "file_name": "CargoROMVariable",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300 900",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": "'wght' 500, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1026,
                "family_id": 269,
                "sort": 4,
                "file_name": "CargoROMVariable",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300 900",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": "'wght' 700, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1027,
                "family_id": 269,
                "sort": 5,
                "file_name": "CargoROMVariable",
                "name": "Heavy",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300 900",
                "css_font_fvd": "n8",
                "css_font_family": null,
                "css_font_fvs": "'wght' 800, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1028,
                "family_id": 269,
                "sort": 6,
                "file_name": "CargoROMVariable",
                "name": "Black",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300 900",
                "css_font_fvd": "n9",
                "css_font_family": null,
                "css_font_fvs": "'wght' 900, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1029,
                "family_id": 269,
                "sort": 7,
                "file_name": "CargoROMItalicVariable",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "300 900",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' -16",
                "staff_pick": false
            }
        ]
    },
    {
        "id": 268,
        "family_name": "ROM Condensed Variable",
        "google_family_name": null,
        "websafe_name": "ROMCondensedVariable",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "sans-serif",
        "axes": [
            {
                "id": 0,
                "title": "Weight",
                "min": 300,
                "max": 900,
                "step": 1,
                "css_fvs": "wght"
            },
            {
                "id": 1,
                "title": "Slant",
                "min": -16,
                "max": 0,
                "step": 0.1,
                "css_fvs": "slnt"
            }
        ],
        "sort": 140,
        "is_active": true,
        "variable": true,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 1014,
                "family_id": 268,
                "sort": 0,
                "file_name": "CargoROMCondensedVariable",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300 900",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": "'wght' 300, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1015,
                "family_id": 268,
                "sort": 1,
                "file_name": "CargoROMCondensedVariable",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300 900",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' 0",
                "staff_pick": true
            },
            {
                "vid": 1016,
                "family_id": 268,
                "sort": 2,
                "file_name": "CargoROMCondensedVariable",
                "name": "Book",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300 900",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": "'wght' 500, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1017,
                "family_id": 268,
                "sort": 3,
                "file_name": "CargoROMCondensedVariable",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300 900",
                "css_font_fvd": "n6",
                "css_font_family": null,
                "css_font_fvs": "'wght' 600, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1018,
                "family_id": 268,
                "sort": 4,
                "file_name": "CargoROMCondensedVariable",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300 900",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": "'wght' 700, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1019,
                "family_id": 268,
                "sort": 5,
                "file_name": "CargoROMCondensedVariable",
                "name": "Heavy",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300 900",
                "css_font_fvd": "n8",
                "css_font_family": null,
                "css_font_fvs": "'wght' 800, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1020,
                "family_id": 268,
                "sort": 6,
                "file_name": "CargoROMCondensedVariable",
                "name": "Black",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300 900",
                "css_font_fvd": "n9",
                "css_font_family": null,
                "css_font_fvs": "'wght' 900, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1021,
                "family_id": 268,
                "sort": 7,
                "file_name": "CargoROMCondensedItalicVariable",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "300 900",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 900, 'slnt' -16",
                "staff_pick": false
            }
        ]
    },
    {
        "id": 58,
        "family_name": "Routed Gothic",
        "google_family_name": null,
        "websafe_name": "RoutedGothic",
        "provider": "cargo",
        "foundry": "Darren Embry",
        "serif": "sans-serif",
        "axes": null,
        "sort": 141,
        "is_active": true,
        "variable": false,
        "open_source": true,
        "license": "/*\n * Routed Gothic © 2020 Darren Embry,\n * https://webonastick.com/fonts/routed-gothic/\n * with Reserved Font Name Routed Gothic.\n * This Font Software is licensed under the SIL Open Font License, Version 1.1. \n */",
        "variants": [
            {
                "vid": 199,
                "family_id": 58,
                "sort": 0,
                "file_name": "RoutedGothic",
                "name": "",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 200,
                "family_id": 58,
                "sort": 1,
                "file_name": "RoutedGothic-HalfItalic",
                "name": "Half Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 267,
        "family_name": "Routed Gothic Narrow",
        "google_family_name": null,
        "websafe_name": "RoutedGothicNarrow",
        "provider": "cargo",
        "foundry": "Darren Embry",
        "serif": "sans-serif",
        "axes": null,
        "sort": 142,
        "is_active": true,
        "variable": false,
        "open_source": true,
        "license": "/*\n * Routed Gothic © 2020 Darren Embry,\n * https://webonastick.com/fonts/routed-gothic/\n * with Reserved Font Name Routed Gothic.\n * This Font Software is licensed under the SIL Open Font License, Version 1.1. \n */",
        "variants": [
            {
                "vid": 1012,
                "family_id": 267,
                "sort": 0,
                "file_name": "RoutedGothicNarrow",
                "name": "",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1013,
                "family_id": 267,
                "sort": 1,
                "file_name": "RoutedGothicNarrow-HalfItalic",
                "name": "Half Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 59,
        "family_name": "Routed Gothic Wide",
        "google_family_name": null,
        "websafe_name": "RoutedGothicWide",
        "provider": "cargo",
        "foundry": "Darren Embry",
        "serif": "sans-serif",
        "axes": null,
        "sort": 143,
        "is_active": true,
        "variable": false,
        "open_source": true,
        "license": "/*\n * Routed Gothic © 2020 Darren Embry,\n * https://webonastick.com/fonts/routed-gothic/\n * with Reserved Font Name Routed Gothic.\n * This Font Software is licensed under the SIL Open Font License, Version 1.1. \n */",
        "variants": [
            {
                "vid": 201,
                "family_id": 59,
                "sort": 0,
                "file_name": "RoutedGothicWide",
                "name": "",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 202,
                "family_id": 59,
                "sort": 1,
                "file_name": "RoutedGothicWide-HalfItalic",
                "name": "Half Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 60,
        "family_name": "Sabon",
        "google_family_name": null,
        "websafe_name": "Sabon",
        "provider": "cargo",
        "foundry": "Jan Tschichold",
        "serif": "serif",
        "axes": null,
        "sort": 145,
        "is_active": true,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 203,
                "family_id": 60,
                "sort": 0,
                "file_name": "Sabon",
                "name": "",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 204,
                "family_id": 60,
                "sort": 1,
                "file_name": "Sabon-Italic",
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 205,
                "family_id": 60,
                "sort": 2,
                "file_name": "Sabon-SemiBold",
                "name": "Semi Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 206,
                "family_id": 60,
                "sort": 3,
                "file_name": "Sabon-SemiBoldItalic",
                "name": "Semi Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 207,
        "family_name": "Sélavy",
        "google_family_name": null,
        "websafe_name": "Selavy",
        "provider": "cargo",
        "foundry": "Nina Stössinger",
        "serif": "sans-serif",
        "axes": null,
        "sort": 149,
        "is_active": true,
        "variable": false,
        "open_source": true,
        "license": "/* \n * Copyright (c) Nina Stössinger (http://ninastoessinger.com/)\n * Copyright (c) Type Brut (https://www.typebrut.com/)\n*/",
        "variants": [
            {
                "vid": 585,
                "family_id": 207,
                "sort": 0,
                "file_name": "Selavy",
                "name": "",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 189,
        "family_name": "Serif System Default",
        "google_family_name": null,
        "websafe_name": "SerifSystemDefault",
        "provider": "system",
        "foundry": null,
        "serif": "serif",
        "axes": null,
        "sort": 150,
        "is_active": true,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 496,
                "family_id": 189,
                "sort": 0,
                "file_name": null,
                "name": "",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": "serif",
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 497,
                "family_id": 189,
                "sort": 1,
                "file_name": null,
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": "serif",
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 498,
                "family_id": 189,
                "sort": 2,
                "file_name": null,
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": "serif",
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 499,
                "family_id": 189,
                "sort": 3,
                "file_name": null,
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": "serif",
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 270,
        "family_name": "Social Variable",
        "google_family_name": null,
        "websafe_name": "SocialVariable",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "sans-serif",
        "axes": [
            {
                "id": 0,
                "title": "Weight",
                "min": 100,
                "max": 900,
                "step": 1,
                "css_fvs": "wght"
            },
            {
                "id": 1,
                "title": "Width",
                "min": 75,
                "max": 100,
                "step": 0.1,
                "css_fvs": "wdth"
            },
            {
                "id": 2,
                "title": "Slant",
                "min": -12,
                "max": 0,
                "step": 0.1,
                "css_fvs": "slnt"
            }
        ],
        "sort": 151,
        "is_active": true,
        "variable": true,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 1030,
                "family_id": 270,
                "sort": 0,
                "file_name": "CargoSocialPlusVariable",
                "name": "Hairline",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 900",
                "css_font_fvd": "n1",
                "css_font_family": null,
                "css_font_fvs": "'wght' 100, 'wdth' 100, 'slnt' 0",
                "staff_pick": true
            },
            {
                "vid": 1031,
                "family_id": 270,
                "sort": 1,
                "file_name": "CargoSocialPlusVariable",
                "name": "Thin",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 900",
                "css_font_fvd": "n2",
                "css_font_family": null,
                "css_font_fvs": "'wght' 200, 'wdth' 100, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1032,
                "family_id": 270,
                "sort": 2,
                "file_name": "CargoSocialPlusVariable",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 900",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": "'wght' 300, 'wdth' 100, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1033,
                "family_id": 270,
                "sort": 3,
                "file_name": "CargoSocialPlusVariable",
                "name": "Book",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 900",
                "css_font_fvd": "n35",
                "css_font_family": null,
                "css_font_fvs": "'wght' 350, 'wdth' 100, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1034,
                "family_id": 270,
                "sort": 4,
                "file_name": "CargoSocialPlusVariable",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 900",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'wdth' 100, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1035,
                "family_id": 270,
                "sort": 5,
                "file_name": "CargoSocialPlusVariable",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 900",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": "'wght' 500, 'wdth' 100, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1036,
                "family_id": 270,
                "sort": 6,
                "file_name": "CargoSocialPlusVariable",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 900",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": "'wght' 700, 'wdth' 100, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1037,
                "family_id": 270,
                "sort": 7,
                "file_name": "CargoSocialPlusVariable",
                "name": "Black",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 900",
                "css_font_fvd": "n9",
                "css_font_family": null,
                "css_font_fvs": "'wght' 900, 'wdth' 100, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1038,
                "family_id": 270,
                "sort": 8,
                "file_name": "CargoSocialItalicPlusVariable",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "100 900",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'wdth' 100, 'slnt' -12",
                "staff_pick": false
            }
        ]
    },
    {
        "id": 271,
        "family_name": "Social Condensed Variable",
        "google_family_name": null,
        "websafe_name": "SocialCondensedVariable",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "sans-serif",
        "axes": [
            {
                "id": 0,
                "title": "Weight",
                "min": 100,
                "max": 900,
                "step": 1,
                "css_fvs": "wght"
            },
            {
                "id": 1,
                "title": "Width",
                "min": 75,
                "max": 100,
                "step": 0.1,
                "css_fvs": "wdth"
            },
            {
                "id": 2,
                "title": "Slant",
                "min": -12,
                "max": 0,
                "step": 0.1,
                "css_fvs": "slnt"
            }
        ],
        "sort": 152,
        "is_active": true,
        "variable": true,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 1039,
                "family_id": 271,
                "sort": 0,
                "file_name": "CargoSocialPlusVariable",
                "name": "Hairline",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 900",
                "css_font_fvd": "n1",
                "css_font_family": null,
                "css_font_fvs": "'wght' 100, 'wdth' 75, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1040,
                "family_id": 271,
                "sort": 1,
                "file_name": "CargoSocialPlusVariable",
                "name": "Thin",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 900",
                "css_font_fvd": "n2",
                "css_font_family": null,
                "css_font_fvs": "'wght' 200, 'wdth' 75, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1041,
                "family_id": 271,
                "sort": 2,
                "file_name": "CargoSocialPlusVariable",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 900",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": "'wght' 300, 'wdth' 75, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1042,
                "family_id": 271,
                "sort": 3,
                "file_name": "CargoSocialPlusVariable",
                "name": "Book",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 900",
                "css_font_fvd": "n35",
                "css_font_family": null,
                "css_font_fvs": "'wght' 350, 'wdth' 75, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1043,
                "family_id": 271,
                "sort": 4,
                "file_name": "CargoSocialPlusVariable",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 900",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'wdth' 75, 'slnt' 0",
                "staff_pick": true
            },
            {
                "vid": 1044,
                "family_id": 271,
                "sort": 5,
                "file_name": "CargoSocialPlusVariable",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 900",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": "'wght' 500, 'wdth' 75, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1045,
                "family_id": 271,
                "sort": 6,
                "file_name": "CargoSocialPlusVariable",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 900",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": "'wght' 700, 'wdth' 75, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1046,
                "family_id": 271,
                "sort": 7,
                "file_name": "CargoSocialPlusVariable",
                "name": "Black",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 900",
                "css_font_fvd": "n9",
                "css_font_family": null,
                "css_font_fvs": "'wght' 900, 'wdth' 75, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1047,
                "family_id": 271,
                "sort": 8,
                "file_name": "CargoSocialItalicPlusVariable",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "100 900",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'wdth' 75, 'slnt' -12",
                "staff_pick": false
            }
        ]
    },
    {
        "id": 209,
        "family_name": "Sono",
        "google_family_name": null,
        "websafe_name": "Sono",
        "provider": "cargo",
        "foundry": "Tyler Finck",
        "serif": "monospace",
        "axes": null,
        "sort": 154,
        "is_active": false,
        "variable": false,
        "open_source": true,
        "license": "/*\n * Copyright (c) 2020, Tyler Finck (https://madebytyler.com)\n * Copyright (c) 2020, Etcetera Type Co (https://www.etc.supply)\n */",
        "variants": [
            {
                "vid": 606,
                "family_id": 209,
                "sort": 0,
                "file_name": "Sono-ExtraLight",
                "name": "Extra Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200",
                "css_font_fvd": "n2",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 601,
                "family_id": 209,
                "sort": 1,
                "file_name": "Sono-Light",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "300",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 600,
                "family_id": 209,
                "sort": 2,
                "file_name": "Sono-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "400",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 602,
                "family_id": 209,
                "sort": 3,
                "file_name": "Sono-Medium",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "500",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 603,
                "family_id": 209,
                "sort": 4,
                "file_name": "Sono-SemiBold",
                "name": "Semi Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "600",
                "css_font_fvd": "n6",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 604,
                "family_id": 209,
                "sort": 5,
                "file_name": "Sono-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "700",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 605,
                "family_id": 209,
                "sort": 6,
                "file_name": "Sono-ExtraBold",
                "name": "Extra Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "900",
                "css_font_fvd": "n9",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 63,
        "family_name": "Standard",
        "google_family_name": null,
        "websafe_name": "Standard",
        "provider": "cargo",
        "foundry": "Bryce Wilner",
        "serif": "sans-serif",
        "axes": null,
        "sort": 161,
        "is_active": true,
        "variable": false,
        "open_source": true,
        "license": "/*\n * By Bryce Wilner\n * brycewilner.com\n */",
        "variants": [
            {
                "vid": 214,
                "family_id": 63,
                "sort": 0,
                "file_name": "Standard-Book",
                "name": "Book",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 215,
                "family_id": 63,
                "sort": 1,
                "file_name": "Standard-BookItalic",
                "name": "Book Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 216,
                "family_id": 63,
                "sort": 2,
                "file_name": "Standard-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 217,
                "family_id": 63,
                "sort": 3,
                "file_name": "Standard-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 64,
        "family_name": "Stanley",
        "google_family_name": null,
        "websafe_name": "Stanley",
        "provider": "cargo",
        "foundry": "Bold Monday",
        "serif": "sans-serif",
        "axes": null,
        "sort": 162,
        "is_active": true,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 218,
                "family_id": 64,
                "sort": 0,
                "file_name": "Stanley-Normal",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 273,
        "family_name": "Synt Variable",
        "google_family_name": null,
        "websafe_name": "SyntVariable",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "serif",
        "axes": [
            {
                "id": 0,
                "title": "Weight",
                "min": 400,
                "max": 900,
                "step": 1,
                "css_fvs": "wght"
            },
            {
                "id": 1,
                "title": "Slant",
                "min": -32,
                "max": 0,
                "step": 0.1,
                "css_fvs": "slnt"
            }
        ],
        "sort": 164,
        "is_active": true,
        "variable": true,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 1056,
                "family_id": 273,
                "sort": 0,
                "file_name": "CargoSyntVariableVF",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "400 900",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' 0",
                "staff_pick": true
            },
            {
                "vid": 1057,
                "family_id": 273,
                "sort": 1,
                "file_name": "CargoSyntVariableVF",
                "name": "Book",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "400 900",
                "css_font_fvd": "n45",
                "css_font_family": null,
                "css_font_fvs": "'wght' 450, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1058,
                "family_id": 273,
                "sort": 2,
                "file_name": "CargoSyntVariableVF",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "400 900",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": "'wght' 500, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1059,
                "family_id": 273,
                "sort": 3,
                "file_name": "CargoSyntVariableVF",
                "name": "Semibold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "400 900",
                "css_font_fvd": "n6",
                "css_font_family": null,
                "css_font_fvs": "'wght' 600, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1060,
                "family_id": 273,
                "sort": 4,
                "file_name": "CargoSyntVariableVF",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "400 900",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": "'wght' 700, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1061,
                "family_id": 273,
                "sort": 5,
                "file_name": "CargoSyntVariableVF",
                "name": "Black",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "400 900",
                "css_font_fvd": "n9",
                "css_font_family": null,
                "css_font_fvs": "'wght' 900, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1067,
                "family_id": 273,
                "sort": 6,
                "file_name": "CargoSyntItalicVariableVF",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "400 900",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' 0",
                "staff_pick": false
            }
        ]
    },
    {
        "id": 285,
        "family_name": "Synt Slant Variable",
        "google_family_name": null,
        "websafe_name": "SyntSlantVariable",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "serif",
        "axes": [
            {
                "id": 0,
                "title": "Weight",
                "min": 400,
                "max": 900,
                "step": 1,
                "css_fvs": "wght"
            },
            {
                "id": 1,
                "title": "Slant",
                "min": -32,
                "max": 0,
                "step": 0.1,
                "css_fvs": "slnt"
            }
        ],
        "sort": 165,
        "is_active": false,
        "variable": true,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 1155,
                "family_id": 285,
                "sort": 0,
                "file_name": "CargoSyntVariableVF",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "400 900",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' -16",
                "staff_pick": false
            },
            {
                "vid": 1156,
                "family_id": 285,
                "sort": 1,
                "file_name": "CargoSyntVariableVF",
                "name": "Book",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "400 900",
                "css_font_fvd": "n45",
                "css_font_family": null,
                "css_font_fvs": "'wght' 450, 'slnt' -16",
                "staff_pick": false
            },
            {
                "vid": 1157,
                "family_id": 285,
                "sort": 2,
                "file_name": "CargoSyntVariableVF",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "400 900",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": "'wght' 500, 'slnt' -16",
                "staff_pick": false
            },
            {
                "vid": 1158,
                "family_id": 285,
                "sort": 3,
                "file_name": "CargoSyntVariableVF",
                "name": "Semibold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "400 900",
                "css_font_fvd": "n6",
                "css_font_family": null,
                "css_font_fvs": "'wght' 600, 'slnt' -16",
                "staff_pick": false
            },
            {
                "vid": 1159,
                "family_id": 285,
                "sort": 4,
                "file_name": "CargoSyntVariableVF",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "400 900",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": "'wght' 700, 'slnt' -16",
                "staff_pick": false
            },
            {
                "vid": 1165,
                "family_id": 285,
                "sort": 5,
                "file_name": "CargoSyntVariableVF",
                "name": "Black",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "400 900",
                "css_font_fvd": "n9",
                "css_font_family": null,
                "css_font_fvs": "'wght' 900, 'slnt' -16",
                "staff_pick": false
            },
            {
                "vid": 1166,
                "family_id": 285,
                "sort": 6,
                "file_name": "CargoSyntItalicVariableVF",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "400 900",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' -16",
                "staff_pick": false
            }
        ]
    },
    {
        "id": 286,
        "family_name": "Synt Turbo Variable",
        "google_family_name": null,
        "websafe_name": "SyntTurboVariable",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "sans-serif",
        "axes": [
            {
                "id": 0,
                "title": "Weight",
                "min": 400,
                "max": 900,
                "step": 1,
                "css_fvs": "wght"
            },
            {
                "id": 1,
                "title": "Slant",
                "min": -32,
                "max": 0,
                "step": 0.1,
                "css_fvs": "slnt"
            }
        ],
        "sort": 166,
        "is_active": false,
        "variable": true,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 1160,
                "family_id": 286,
                "sort": 0,
                "file_name": "CargoSyntVariableVF",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "400 900",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' -32",
                "staff_pick": false
            },
            {
                "vid": 1161,
                "family_id": 286,
                "sort": 1,
                "file_name": "CargoSyntVariableVF",
                "name": "Book",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "400 900",
                "css_font_fvd": "n45",
                "css_font_family": null,
                "css_font_fvs": "'wght' 450, 'slnt' -32",
                "staff_pick": false
            },
            {
                "vid": 1162,
                "family_id": 286,
                "sort": 2,
                "file_name": "CargoSyntVariableVF",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "400 900",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": "'wght' 500, 'slnt' -32",
                "staff_pick": false
            },
            {
                "vid": 1163,
                "family_id": 286,
                "sort": 3,
                "file_name": "CargoSyntVariableVF",
                "name": "Semibold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "400 900",
                "css_font_fvd": "n6",
                "css_font_family": null,
                "css_font_fvs": "'wght' 600, 'slnt' -32",
                "staff_pick": false
            },
            {
                "vid": 1164,
                "family_id": 286,
                "sort": 4,
                "file_name": "CargoSyntVariableVF",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "400 900",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": "'wght' 700, 'slnt' -32",
                "staff_pick": false
            },
            {
                "vid": 1167,
                "family_id": 286,
                "sort": 5,
                "file_name": "CargoSyntVariableVF",
                "name": "Black",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "400 900",
                "css_font_fvd": "n9",
                "css_font_family": null,
                "css_font_fvs": "'wght' 900, 'slnt' -32",
                "staff_pick": false
            },
            {
                "vid": 1168,
                "family_id": 286,
                "sort": 6,
                "file_name": "CargoSyntItalicVariableVF",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "400 900",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' -32",
                "staff_pick": false
            }
        ]
    },
    {
        "id": 234,
        "family_name": "TeX Gyre Heros",
        "google_family_name": null,
        "websafe_name": "TeXGyreHeros",
        "provider": "cargo",
        "foundry": "GUST E-Foundry",
        "serif": "sans-serif",
        "axes": null,
        "sort": 167,
        "is_active": true,
        "variable": false,
        "open_source": true,
        "license": "/*\n * Copyright (c) GUST E-Foundry\n * gust.org.pl/projects/e-foundry/tex-gyre/heros\n */",
        "variants": [
            {
                "vid": 759,
                "family_id": 234,
                "sort": 0,
                "file_name": "TeXGyreHeros-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 760,
                "family_id": 234,
                "sort": 1,
                "file_name": "TeXGyreHeros-Italic",
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 761,
                "family_id": 234,
                "sort": 2,
                "file_name": "TeXGyreHeros-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 762,
                "family_id": 234,
                "sort": 3,
                "file_name": "TeXGyreHeros-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 67,
        "family_name": "TeX Gyre Heros Condensed",
        "google_family_name": null,
        "websafe_name": "TeXGyreHerosCondensed",
        "provider": "cargo",
        "foundry": "GUST E-Foundry",
        "serif": "sans-serif",
        "axes": null,
        "sort": 168,
        "is_active": true,
        "variable": false,
        "open_source": true,
        "license": "/*\n * Copyright (c) GUST E-Foundry\n * gust.org.pl/projects/e-foundry/tex-gyre/heros\n */",
        "variants": [
            {
                "vid": 224,
                "family_id": 67,
                "sort": 0,
                "file_name": "TeXGyreHerosCondensed-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 225,
                "family_id": 67,
                "sort": 1,
                "file_name": "TeXGyreHerosCondensed-Italic",
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 226,
                "family_id": 67,
                "sort": 2,
                "file_name": "TeXGyreHerosCondensed-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 227,
                "family_id": 67,
                "sort": 3,
                "file_name": "TeXGyreHerosCondensed-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 212,
        "family_name": "Tapeworm",
        "google_family_name": null,
        "websafe_name": "Tapeworm",
        "provider": "cargo",
        "foundry": "",
        "serif": "sans-serif",
        "axes": null,
        "sort": 169,
        "is_active": false,
        "variable": false,
        "open_source": true,
        "license": "/* The computer font Tapeworm was created by \n* Harold Lohner, 1998, and placed into the public domain by him. Tapeworm is based on the work of the artist Ed Ruscha. The style suggests simple letters formed with masking tape.\n* Harold Lohner\n* HLohner@aol.com\n* http://members.aol.com/fontner\n*/",
        "variants": [
            {
                "vid": 649,
                "family_id": 212,
                "sort": 1,
                "file_name": "Tapeworm",
                "name": "",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 66,
        "family_name": "Terminal Grotesque",
        "google_family_name": null,
        "websafe_name": "TerminalGrotesque",
        "provider": "cargo",
        "foundry": "Raphaël Bastide",
        "serif": "sans-serif",
        "axes": null,
        "sort": 170,
        "is_active": true,
        "variable": false,
        "open_source": true,
        "license": "/*\n * Copyright (c) 2012, Tyler Finck <hello@sursly.com>, with Reserved Font Name: \"Blackout\".\n * \n * This Font Software is licensed under the SIL Open Font License, Version 1.1.\n * This license is copied below, and is also available with a FAQ at:\n * http://scripts.sil.org/OFL\n * \n * Version 2.0 - 18 March 2012\n */\n\n",
        "variants": [
            {
                "vid": 223,
                "family_id": 66,
                "sort": 0,
                "file_name": "TerminalGrotesque",
                "name": "",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 266,
        "family_name": "Times",
        "google_family_name": null,
        "websafe_name": "Times",
        "provider": "system",
        "foundry": "",
        "serif": "serif",
        "axes": null,
        "sort": 172,
        "is_active": true,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 1008,
                "family_id": 266,
                "sort": 0,
                "file_name": null,
                "name": "Roman",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "400",
                "css_font_fvd": "n4",
                "css_font_family": "'Times', 'Times New Roman', serif",
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1009,
                "family_id": 266,
                "sort": 1,
                "file_name": null,
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "400",
                "css_font_fvd": "i4",
                "css_font_family": "'Times', 'Times New Roman', serif",
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1010,
                "family_id": 266,
                "sort": 2,
                "file_name": null,
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "700",
                "css_font_fvd": "n7",
                "css_font_family": "'Times', 'Times New Roman', serif",
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1011,
                "family_id": 266,
                "sort": 3,
                "file_name": null,
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "700",
                "css_font_fvd": "i7",
                "css_font_family": "'Times', 'Times New Roman', serif",
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 68,
        "family_name": "Titling Gothic FB Condensed",
        "google_family_name": null,
        "websafe_name": "TitlingGothicFBCondensed",
        "provider": "cargo",
        "foundry": "Font Bureau",
        "serif": "sans-serif",
        "axes": null,
        "sort": 173,
        "is_active": false,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 229,
                "family_id": 68,
                "sort": 0,
                "file_name": "TitlingGothicFBCondensed-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1189,
                "family_id": 68,
                "sort": 1,
                "file_name": "TitlingGothicFBCondensed-RegularItalic",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 228,
                "family_id": 68,
                "sort": 1,
                "file_name": "TitlingGothicFBCondensed-Medium",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "500",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1190,
                "family_id": 68,
                "sort": 3,
                "file_name": "TitlingGothicFBCondensed-MediumItalic",
                "name": "Medium Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "500",
                "css_font_fvd": "i5",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 69,
        "family_name": "Titling Gothic FB Narrow",
        "google_family_name": null,
        "websafe_name": "TitlingGothicFBNarrow",
        "provider": "cargo",
        "foundry": "Font Bureau",
        "serif": "sans-serif",
        "axes": null,
        "sort": 174,
        "is_active": false,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 231,
                "family_id": 69,
                "sort": 0,
                "file_name": "TitlingGothicFBNarrow-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1191,
                "family_id": 69,
                "sort": 1,
                "file_name": "TitlingGothicFBNarrow-RegularItalic",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 230,
                "family_id": 69,
                "sort": 1,
                "file_name": "TitlingGothicFBNarrow-Medium",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "500",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1192,
                "family_id": 69,
                "sort": 3,
                "file_name": "TitlingGothicFBNarrow-MediumItalic",
                "name": "Medium Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "500",
                "css_font_fvd": "i5",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 70,
        "family_name": "Titling Gothic FB Normal",
        "google_family_name": null,
        "websafe_name": "TitlingGothicFBNormal",
        "provider": "cargo",
        "foundry": "Font Bureau",
        "serif": "sans-serif",
        "axes": null,
        "sort": 175,
        "is_active": false,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 234,
                "family_id": 70,
                "sort": 0,
                "file_name": "TitlingGothicFBNormal-Light",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200",
                "css_font_fvd": "n2",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1193,
                "family_id": 70,
                "sort": 1,
                "file_name": "TitlingGothicFBNormal-LightItalic",
                "name": "Light Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "200",
                "css_font_fvd": "i2",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 233,
                "family_id": 70,
                "sort": 1,
                "file_name": "TitlingGothicFBNormal-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 232,
                "family_id": 70,
                "sort": 2,
                "file_name": "TitlingGothicFBNormal-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1194,
                "family_id": 70,
                "sort": 3,
                "file_name": "TitlingGothicFBNormal-RegularItalic",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1195,
                "family_id": 70,
                "sort": 5,
                "file_name": "TitlingGothicFBNormal-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 71,
        "family_name": "Titling Gothic FB Wide",
        "google_family_name": null,
        "websafe_name": "TitlingGothicFBWide",
        "provider": "cargo",
        "foundry": "Font Bureau",
        "serif": "sans-serif",
        "axes": null,
        "sort": 176,
        "is_active": false,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 235,
                "family_id": 71,
                "sort": 0,
                "file_name": "TitlingGothicFBWide",
                "name": "",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 236,
                "family_id": 71,
                "sort": 1,
                "file_name": "TitlingGothicFBWide-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1196,
                "family_id": 71,
                "sort": 2,
                "file_name": "TitlingGothicFBWide-Italic",
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 1197,
                "family_id": 71,
                "sort": 3,
                "file_name": "TitlingGothicFBWide-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 214,
        "family_name": "Tratex",
        "google_family_name": null,
        "websafe_name": "Tratex",
        "provider": "cargo",
        "foundry": "Karl-Gustav Gustafson",
        "serif": "sans-serif",
        "axes": null,
        "sort": 177,
        "is_active": false,
        "variable": false,
        "open_source": true,
        "license": null,
        "variants": [
            {
                "vid": 650,
                "family_id": 214,
                "sort": 0,
                "file_name": "Tratex-Vit",
                "name": "Vit",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "400",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 651,
                "family_id": 214,
                "sort": 1,
                "file_name": "Tratex-Svart",
                "name": "Svart",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "500",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 72,
        "family_name": "Typewriter Condensed",
        "google_family_name": null,
        "websafe_name": "TypewriterCondensed",
        "provider": "cargo",
        "foundry": "Volker Busse",
        "serif": "monospace",
        "axes": null,
        "sort": 178,
        "is_active": true,
        "variable": false,
        "open_source": true,
        "license": "/*\n * By Volker Busse\n */",
        "variants": [
            {
                "vid": 237,
                "family_id": 72,
                "sort": 0,
                "file_name": "TypeWriterCondensed-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 238,
                "family_id": 72,
                "sort": 1,
                "file_name": "TypeWriterCondensed-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 126,
        "family_name": "UnifrakturMaguntia",
        "google_family_name": "UnifrakturMaguntia",
        "websafe_name": "UnifrakturMaguntia",
        "provider": "google",
        "foundry": "j. “mach” wust",
        "serif": "serif",
        "axes": null,
        "sort": 179,
        "is_active": true,
        "variable": false,
        "open_source": true,
        "license": null,
        "variants": [
            {
                "vid": 403,
                "family_id": 126,
                "sort": 0,
                "file_name": null,
                "name": "Regular",
                "google_variant_name": "400",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 73,
        "family_name": "VCR OSD Mono",
        "google_family_name": null,
        "websafe_name": "VCROSDMono",
        "provider": "cargo",
        "foundry": "Riciery Santos Leal",
        "serif": "monospace",
        "axes": null,
        "sort": 180,
        "is_active": true,
        "variable": false,
        "open_source": true,
        "license": "/*\n * By Riciery Santos Leal\n */",
        "variants": [
            {
                "vid": 239,
                "family_id": 73,
                "sort": 0,
                "file_name": "VCROSD-Mono",
                "name": "",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 127,
        "family_name": "Vollkorn",
        "google_family_name": "Vollkorn",
        "websafe_name": "Vollkorn",
        "provider": "google",
        "foundry": "Friedrich Althausen",
        "serif": "serif",
        "axes": null,
        "sort": 181,
        "is_active": false,
        "variable": false,
        "open_source": true,
        "license": null,
        "variants": [
            {
                "vid": 404,
                "family_id": 127,
                "sort": 0,
                "file_name": null,
                "name": "Regular",
                "google_variant_name": "400",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 405,
                "family_id": 127,
                "sort": 1,
                "file_name": null,
                "name": "Regular Italic",
                "google_variant_name": "400italic",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 406,
                "family_id": 127,
                "sort": 2,
                "file_name": null,
                "name": "Bold",
                "google_variant_name": "700",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 407,
                "family_id": 127,
                "sort": 3,
                "file_name": null,
                "name": "Bold Italic",
                "google_variant_name": "700italic",
                "css_font_style": null,
                "css_font_weight": null,
                "css_font_fvd": null,
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 272,
        "family_name": "Walter Neue Variable",
        "google_family_name": null,
        "websafe_name": "WalterNeueVariable",
        "provider": "cargo",
        "foundry": "ABC Dinamo",
        "serif": "sans-serif",
        "axes": [
            {
                "id": 0,
                "title": "Weight",
                "min": 100,
                "max": 800,
                "step": 1,
                "css_fvs": "wght"
            },
            {
                "id": 1,
                "title": "Slant",
                "min": -8,
                "max": 0,
                "step": 0.1,
                "css_fvs": "slnt"
            }
        ],
        "sort": 182,
        "is_active": true,
        "variable": true,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 1048,
                "family_id": 272,
                "sort": 0,
                "file_name": "CargoWalterNeueVariable",
                "name": "Thin",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 900",
                "css_font_fvd": "n2",
                "css_font_family": null,
                "css_font_fvs": "'wght' 200, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1049,
                "family_id": 272,
                "sort": 1,
                "file_name": "CargoWalterNeueVariable",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 900",
                "css_font_fvd": "n3",
                "css_font_family": null,
                "css_font_fvs": "'wght' 300, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1050,
                "family_id": 272,
                "sort": 2,
                "file_name": "CargoWalterNeueVariable",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 900",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' 0",
                "staff_pick": true
            },
            {
                "vid": 1051,
                "family_id": 272,
                "sort": 3,
                "file_name": "CargoWalterNeueVariable",
                "name": "Medium",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 900",
                "css_font_fvd": "n5",
                "css_font_family": null,
                "css_font_fvs": "'wght' 500, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1052,
                "family_id": 272,
                "sort": 4,
                "file_name": "CargoWalterNeueVariable",
                "name": "Semibold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 900",
                "css_font_fvd": "n6",
                "css_font_family": null,
                "css_font_fvs": "'wght' 600, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1053,
                "family_id": 272,
                "sort": 5,
                "file_name": "CargoWalterNeueVariable",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 900",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": "'wght' 700, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1054,
                "family_id": 272,
                "sort": 6,
                "file_name": "CargoWalterNeueVariable",
                "name": "Extrabold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "100 900",
                "css_font_fvd": "n9",
                "css_font_family": null,
                "css_font_fvs": "'wght' 800, 'slnt' 0",
                "staff_pick": false
            },
            {
                "vid": 1055,
                "family_id": 272,
                "sort": 7,
                "file_name": "CargoWalterNeueItalicVariable",
                "name": "Regular Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "100 900",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": "'wght' 400, 'slnt' -8",
                "staff_pick": false
            }
        ]
    },
    {
        "id": 74,
        "family_name": "Whitman",
        "google_family_name": null,
        "websafe_name": "Whitman",
        "provider": "cargo",
        "foundry": "Font Bureau",
        "serif": "serif",
        "axes": null,
        "sort": 183,
        "is_active": true,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 240,
                "family_id": 74,
                "sort": 0,
                "file_name": "Whitman-Roman",
                "name": "Roman",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 241,
                "family_id": 74,
                "sort": 1,
                "file_name": "Whitman-Italic",
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 242,
                "family_id": 74,
                "sort": 2,
                "file_name": "Whitman-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 243,
                "family_id": 74,
                "sort": 3,
                "file_name": "Whitman-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 79,
        "family_name": "Williams Caslon Text",
        "google_family_name": null,
        "websafe_name": "WilliamsCaslonText",
        "provider": "cargo",
        "foundry": "Font Bureau",
        "serif": "serif",
        "axes": null,
        "sort": 184,
        "is_active": true,
        "variable": false,
        "open_source": false,
        "license": null,
        "variants": [
            {
                "vid": 280,
                "family_id": 79,
                "sort": 0,
                "file_name": "WilliamsCaslonText-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 471,
                "family_id": 79,
                "sort": 1,
                "file_name": "WilliamsCaslonText-Italic",
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 472,
                "family_id": 79,
                "sort": 2,
                "file_name": "WilliamsCaslonText-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 473,
                "family_id": 79,
                "sort": 3,
                "file_name": "WilliamsCaslonText-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 80,
        "family_name": "Wremena",
        "google_family_name": null,
        "websafe_name": "Wremena",
        "provider": "cargo",
        "foundry": "The Temporary State",
        "serif": "serif",
        "axes": null,
        "sort": 185,
        "is_active": true,
        "variable": false,
        "open_source": true,
        "license": "/*\n * By The Temporary State\n * temporarystate.net\n */",
        "variants": [
            {
                "vid": 285,
                "family_id": 80,
                "sort": 0,
                "file_name": "Wremena-Light",
                "name": "Light",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "200",
                "css_font_fvd": "n2",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 284,
                "family_id": 80,
                "sort": 1,
                "file_name": "Wremena-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 286,
                "family_id": 80,
                "sort": 2,
                "file_name": "Wremena-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    },
    {
        "id": 31,
        "family_name": "iA Writer Quattro",
        "google_family_name": null,
        "websafe_name": "iAWriterQuattro",
        "provider": "cargo",
        "foundry": "iA Writer",
        "serif": "sans-serif",
        "axes": null,
        "sort": 188,
        "is_active": true,
        "variable": false,
        "open_source": true,
        "license": "/*\n * Copyright © 2018 Information Architects Inc. with Reserved Font Name \"iA Writer\"\n * \n * Based on IBM Plex Typeface\n * Copyright © 2017 IBM Corp. with Reserved Font Name \"Plex\"\n * \n * https://ia.net\n */",
        "variants": [
            {
                "vid": 94,
                "family_id": 31,
                "sort": 0,
                "file_name": "iAWriterQuattro-Regular",
                "name": "Regular",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "normal",
                "css_font_fvd": "n4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 95,
                "family_id": 31,
                "sort": 1,
                "file_name": "iAWriterQuattro-Italic",
                "name": "Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "normal",
                "css_font_fvd": "i4",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 96,
                "family_id": 31,
                "sort": 2,
                "file_name": "iAWriterQuattro-Bold",
                "name": "Bold",
                "google_variant_name": null,
                "css_font_style": "normal",
                "css_font_weight": "bold",
                "css_font_fvd": "n7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            },
            {
                "vid": 97,
                "family_id": 31,
                "sort": 3,
                "file_name": "iAWriterQuattro-BoldItalic",
                "name": "Bold Italic",
                "google_variant_name": null,
                "css_font_style": "italic",
                "css_font_weight": "bold",
                "css_font_fvd": "i7",
                "css_font_family": null,
                "css_font_fvs": null,
                "staff_pick": false
            }
        ]
    }
]